//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import dayjs from 'dayjs';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AnomalieDemandeTransportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Recherche pour toutes les anomalies de demandes de transports
     * @return OK
     */
    rechercherAnomaliesDemandeTransport(): Observable<AnomalieDemandeTransportDto[]> {
        let url_ = this.baseUrl + "/api/AnomalieDemandeTransport/RechercherAnomaliesDemandeTransport";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRechercherAnomaliesDemandeTransport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRechercherAnomaliesDemandeTransport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AnomalieDemandeTransportDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AnomalieDemandeTransportDto[]>;
        }));
    }

    protected processRechercherAnomaliesDemandeTransport(response: HttpResponseBase): Observable<AnomalieDemandeTransportDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AnomalieDemandeTransportDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ArticleClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retourne la liste des articles
     * @return OK
     */
    getArticles(): Observable<ArticleDto[]> {
        let url_ = this.baseUrl + "/api/Article/GetArticles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArticles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArticles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArticleDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArticleDto[]>;
        }));
    }

    protected processGetArticles(response: HttpResponseBase): Observable<ArticleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ArticleDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retourne un article via son id
     * @return OK
     */
    getArticleById(id: number): Observable<ArticleDto> {
        let url_ = this.baseUrl + "/api/Article/GetArticleById/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArticleById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArticleById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArticleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArticleDto>;
        }));
    }

    protected processGetArticleById(response: HttpResponseBase): Observable<ArticleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArticleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Supprime un article par son id
     * @return OK
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Article/Delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Met à jour un article
     * @param body (optional) 
     * @return Created
     */
    update(body: ArticleDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Article/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Créé un article
     * @param body (optional) 
     * @return OK
     */
    create(body: ArticleDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Article/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retourne un article par son code
     * @param code (optional) 
     * @return OK
     */
    getArticleParCode(code: string | undefined): Observable<ArticleDto> {
        let url_ = this.baseUrl + "/api/Article/GetArticleParCode?";
        if (code === null)
            throw new globalThis.Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArticleParCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArticleParCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArticleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArticleDto>;
        }));
    }

    protected processGetArticleParCode(response: HttpResponseBase): Observable<ArticleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArticleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CarteClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Récupère une tuile de la carte depuis le storage vacant azure créé à cet effet
     * @param zoom niveau de zoom
     * @param x position x
     * @param y position y
     * @return OK
     */
    getTuile(zoom: string, x: string, y: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Carte/GetTuile/{zoom}/{x}/{y}";
        if (zoom === undefined || zoom === null)
            throw new globalThis.Error("The parameter 'zoom' must be defined.");
        url_ = url_.replace("{zoom}", encodeURIComponent("" + zoom));
        if (x === undefined || x === null)
            throw new globalThis.Error("The parameter 'x' must be defined.");
        url_ = url_.replace("{x}", encodeURIComponent("" + x));
        if (y === undefined || y === null)
            throw new globalThis.Error("The parameter 'y' must be defined.");
        url_ = url_.replace("{y}", encodeURIComponent("" + y));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTuile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTuile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetTuile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ColisClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Obtient un nouveau colis auto-généré et créé en bdd
     * @param articleId (optional) 
     * @return OK
     */
    obtenirNouveauColis(articleId: number | undefined): Observable<PairingColisDto> {
        let url_ = this.baseUrl + "/api/Colis/ObtenirNouveauColis?";
        if (articleId === null)
            throw new globalThis.Error("The parameter 'articleId' cannot be null.");
        else if (articleId !== undefined)
            url_ += "articleId=" + encodeURIComponent("" + articleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObtenirNouveauColis(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObtenirNouveauColis(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PairingColisDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PairingColisDto>;
        }));
    }

    protected processObtenirNouveauColis(response: HttpResponseBase): Observable<PairingColisDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PairingColisDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Appaire une pièce d'un tag à un colis
     * @param body (optional) 
     * @return OK
     */
    appairer(body: PairingColisDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Colis/Appairer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppairer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppairer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAppairer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Appaire une pièce d'un tag à un colis
    sans message d'erreur bloquant (ex: balise deja apparairé/desappairé)
     * @param body (optional) 
     * @return OK
     */
    appairerColisSansMessageErreur(body: PairingColisDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Colis/AppairerColisSansMessageErreur";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppairerColisSansMessageErreur(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppairerColisSansMessageErreur(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAppairerColisSansMessageErreur(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * DesAppaire une pièce d'un colis
    et le reassocie à sa DPE d'origine
     * @param pieceId (optional) 
     * @return OK
     */
    desappairerPieceDuColis(pieceId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Colis/DesappairerPieceDuColis?";
        if (pieceId === null)
            throw new globalThis.Error("The parameter 'pieceId' cannot be null.");
        else if (pieceId !== undefined)
            url_ += "pieceId=" + encodeURIComponent("" + pieceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDesappairerPieceDuColis(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDesappairerPieceDuColis(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDesappairerPieceDuColis(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * DesAppaire les pièces d'un colis
    et le reassocie à sa DPE d'origine
    pas de message d'erreur quand la piece n'est pas appairée
     * @param colisId (optional) 
     * @param body (optional) 
     * @return OK
     */
    desappairerPieceDuColisSansMessage(colisId: number | undefined, body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Colis/DesappairerPieceDuColisSansMessage?";
        if (colisId === null)
            throw new globalThis.Error("The parameter 'colisId' cannot be null.");
        else if (colisId !== undefined)
            url_ += "colisId=" + encodeURIComponent("" + colisId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDesappairerPieceDuColisSansMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDesappairerPieceDuColisSansMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDesappairerPieceDuColisSansMessage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Recherche les infos d'un colis pour l'impression d'une etiquette
     * @param dpeId (optional) 
     * @return OK
     */
    rechercherColisPourImpressionEtiquette(dpeId: number | undefined): Observable<SearchColisEtiquetteDto[]> {
        let url_ = this.baseUrl + "/api/Colis/RechercherColisPourImpressionEtiquette?";
        if (dpeId === null)
            throw new globalThis.Error("The parameter 'dpeId' cannot be null.");
        else if (dpeId !== undefined)
            url_ += "dpeId=" + encodeURIComponent("" + dpeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRechercherColisPourImpressionEtiquette(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRechercherColisPourImpressionEtiquette(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchColisEtiquetteDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchColisEtiquetteDto[]>;
        }));
    }

    protected processRechercherColisPourImpressionEtiquette(response: HttpResponseBase): Observable<SearchColisEtiquetteDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SearchColisEtiquetteDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Recherche les infos d'un colis pour l'impression d'une etiquette
     * @param numDpe (optional) 
     * @param numColis (optional) 
     * @param numOF (optional) 
     * @param numPiece (optional) 
     * @return OK
     */
    rechercherColisAvecParametresPourImpressionEtiquette(numDpe: string | undefined, numColis: string | undefined, numOF: string | undefined, numPiece: string | undefined): Observable<SearchColisEtiquetteDto[]> {
        let url_ = this.baseUrl + "/api/Colis/RechercherColisAvecParametresPourImpressionEtiquette?";
        if (numDpe === null)
            throw new globalThis.Error("The parameter 'numDpe' cannot be null.");
        else if (numDpe !== undefined)
            url_ += "numDpe=" + encodeURIComponent("" + numDpe) + "&";
        if (numColis === null)
            throw new globalThis.Error("The parameter 'numColis' cannot be null.");
        else if (numColis !== undefined)
            url_ += "numColis=" + encodeURIComponent("" + numColis) + "&";
        if (numOF === null)
            throw new globalThis.Error("The parameter 'numOF' cannot be null.");
        else if (numOF !== undefined)
            url_ += "numOF=" + encodeURIComponent("" + numOF) + "&";
        if (numPiece === null)
            throw new globalThis.Error("The parameter 'numPiece' cannot be null.");
        else if (numPiece !== undefined)
            url_ += "numPiece=" + encodeURIComponent("" + numPiece) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRechercherColisAvecParametresPourImpressionEtiquette(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRechercherColisAvecParametresPourImpressionEtiquette(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchColisEtiquetteDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchColisEtiquetteDto[]>;
        }));
    }

    protected processRechercherColisAvecParametresPourImpressionEtiquette(response: HttpResponseBase): Observable<SearchColisEtiquetteDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SearchColisEtiquetteDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Recherche le colis pour avoir les informations sur l'etiquette
     * @param idColis (optional) 
     * @return OK
     */
    obtenirInformationEtiquette(idColis: number | undefined): Observable<EtiquetteDto> {
        let url_ = this.baseUrl + "/api/Colis/ObtenirInformationEtiquette?";
        if (idColis === null)
            throw new globalThis.Error("The parameter 'idColis' cannot be null.");
        else if (idColis !== undefined)
            url_ += "idColis=" + encodeURIComponent("" + idColis) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObtenirInformationEtiquette(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObtenirInformationEtiquette(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EtiquetteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EtiquetteDto>;
        }));
    }

    protected processObtenirInformationEtiquette(response: HttpResponseBase): Observable<EtiquetteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EtiquetteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Recherche les colis d'une DPE
     * @param dpeId (optional) 
     * @return OK
     */
    rechercherColisParDpeId(dpeId: number | undefined): Observable<PairingColisDto[]> {
        let url_ = this.baseUrl + "/api/Colis/RechercherColisParDpeId?";
        if (dpeId === null)
            throw new globalThis.Error("The parameter 'dpeId' cannot be null.");
        else if (dpeId !== undefined)
            url_ += "dpeId=" + encodeURIComponent("" + dpeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRechercherColisParDpeId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRechercherColisParDpeId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PairingColisDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PairingColisDto[]>;
        }));
    }

    protected processRechercherColisParDpeId(response: HttpResponseBase): Observable<PairingColisDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PairingColisDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Vérifie que le colis fait partie de la DPE et le valide
     * @param dpeId (optional) 
     * @param body (optional) 
     * @return OK
     */
    validerChargementColis(dpeId: number | undefined, body: PairingColisDto | undefined): Observable<PairingColisDto> {
        let url_ = this.baseUrl + "/api/Colis/ValiderChargementColis?";
        if (dpeId === null)
            throw new globalThis.Error("The parameter 'dpeId' cannot be null.");
        else if (dpeId !== undefined)
            url_ += "dpeId=" + encodeURIComponent("" + dpeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValiderChargementColis(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValiderChargementColis(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PairingColisDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PairingColisDto>;
        }));
    }

    protected processValiderChargementColis(response: HttpResponseBase): Observable<PairingColisDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PairingColisDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Vérifie que le colis fait partie de la DPE et le valide via le nom du colis
     * @param nomColis (optional) 
     * @param dpeId (optional) 
     * @return OK
     */
    validerChargementColisParCode(nomColis: string | undefined, dpeId: number | undefined): Observable<PairingColisDto> {
        let url_ = this.baseUrl + "/api/Colis/ValiderChargementColisParCode?";
        if (nomColis === null)
            throw new globalThis.Error("The parameter 'nomColis' cannot be null.");
        else if (nomColis !== undefined)
            url_ += "nomColis=" + encodeURIComponent("" + nomColis) + "&";
        if (dpeId === null)
            throw new globalThis.Error("The parameter 'dpeId' cannot be null.");
        else if (dpeId !== undefined)
            url_ += "dpeId=" + encodeURIComponent("" + dpeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValiderChargementColisParCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValiderChargementColisParCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PairingColisDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PairingColisDto>;
        }));
    }

    protected processValiderChargementColisParCode(response: HttpResponseBase): Observable<PairingColisDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PairingColisDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Recherche les colis et leurs pièces
     * @param colis (optional) 
     * @param searchMode (optional) 
     * @return OK
     */
    rechercherColisDesappairage(colis: string | undefined, searchMode: number | undefined): Observable<PairingColisDto> {
        let url_ = this.baseUrl + "/api/Colis/RechercherColisDesappairage?";
        if (colis === null)
            throw new globalThis.Error("The parameter 'colis' cannot be null.");
        else if (colis !== undefined)
            url_ += "colis=" + encodeURIComponent("" + colis) + "&";
        if (searchMode === null)
            throw new globalThis.Error("The parameter 'searchMode' cannot be null.");
        else if (searchMode !== undefined)
            url_ += "searchMode=" + encodeURIComponent("" + searchMode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRechercherColisDesappairage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRechercherColisDesappairage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PairingColisDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PairingColisDto>;
        }));
    }

    protected processRechercherColisDesappairage(response: HttpResponseBase): Observable<PairingColisDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PairingColisDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Désappaire les colis
     * @param id (optional) 
     * @return OK
     */
    desappairerColis(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Colis/DesappairerColis?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDesappairerColis(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDesappairerColis(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDesappairerColis(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Mise a jour des informations article du colis
     * @param body (optional) 
     * @return OK
     */
    modifierInfosArticleColis(body: PairingColisDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Colis/ModifierInfosArticleColis";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processModifierInfosArticleColis(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processModifierInfosArticleColis(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processModifierInfosArticleColis(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Génère un word depuis une DPE pour obtenir son étiquette
     * @param colisId (optional) 
     * @return OK
     */
    obtenirEtiquetteFormatWord(colisId: number | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Colis/ObtenirEtiquetteFormatWord?";
        if (colisId === null)
            throw new globalThis.Error("The parameter 'colisId' cannot be null.");
        else if (colisId !== undefined)
            url_ += "colisId=" + encodeURIComponent("" + colisId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObtenirEtiquetteFormatWord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObtenirEtiquetteFormatWord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processObtenirEtiquetteFormatWord(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param colisId (optional) 
     * @return OK
     */
    obtenirNomColis(colisId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Colis/ObtenirNomColis?";
        if (colisId === null)
            throw new globalThis.Error("The parameter 'colisId' cannot be null.");
        else if (colisId !== undefined)
            url_ += "colisId=" + encodeURIComponent("" + colisId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObtenirNomColis(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObtenirNomColis(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processObtenirNomColis(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CommentaireClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retourne la liste des commentaires
     * @return OK
     */
    getCommentaires(): Observable<CommentaireDto[]> {
        let url_ = this.baseUrl + "/api/Commentaire/GetCommentaires";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommentaires(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommentaires(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommentaireDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommentaireDto[]>;
        }));
    }

    protected processGetCommentaires(response: HttpResponseBase): Observable<CommentaireDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommentaireDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retourne un commentaire via son id
     * @return OK
     */
    getCommentaireById(id: number): Observable<CommentaireDto> {
        let url_ = this.baseUrl + "/api/Commentaire/GetCommentaireById/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommentaireById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommentaireById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommentaireDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommentaireDto>;
        }));
    }

    protected processGetCommentaireById(response: HttpResponseBase): Observable<CommentaireDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommentaireDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Supprime un commentaire par son id
     * @return OK
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Commentaire/Delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Met à jour un commentaire
     * @param body (optional) 
     * @return Created
     */
    update(body: CommentaireDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Commentaire/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Créé un article
     * @param body (optional) 
     * @return OK
     */
    create(body: CommentaireDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Commentaire/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DemandeApproTagClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retourne tous les demandes d'approvisionnement de tags
     * @return OK
     */
    obtenirDemandes(): Observable<DemandeApproTagDto[]> {
        let url_ = this.baseUrl + "/api/DemandeApproTag/ObtenirDemandes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObtenirDemandes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObtenirDemandes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DemandeApproTagDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DemandeApproTagDto[]>;
        }));
    }

    protected processObtenirDemandes(response: HttpResponseBase): Observable<DemandeApproTagDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DemandeApproTagDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Met à jour une demande d'approvisionnement de tags
     * @param body (optional) 
     * @return Created
     */
    updateDemandeApproTag(body: DemandeApproTagDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/DemandeApproTag/UpdateDemandeApproTag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDemandeApproTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDemandeApproTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateDemandeApproTag(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Créé une demande d'approvisionnement de tags
     * @param body (optional) 
     * @return OK
     */
    creerDemandeApproTag(body: DemandeApproTagDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/DemandeApproTag/CreerDemandeApproTag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreerDemandeApproTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreerDemandeApproTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreerDemandeApproTag(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Supprime une demande par son id
     * @return OK
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/DemandeApproTag/Delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DemandeExpeditionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Recherche les dpes par ordre de priorité
     * @param exclureExpediees (optional) 
     * @param exclureAnnulees (optional) 
     * @return OK
     */
    obtenirDpesTriesParPriorite(exclureExpediees: boolean | undefined, exclureAnnulees: boolean | undefined): Observable<SearchDemandeExpeditionDto[]> {
        let url_ = this.baseUrl + "/api/DemandeExpedition/ObtenirDpesTriesParPriorite?";
        if (exclureExpediees === null)
            throw new globalThis.Error("The parameter 'exclureExpediees' cannot be null.");
        else if (exclureExpediees !== undefined)
            url_ += "exclureExpediees=" + encodeURIComponent("" + exclureExpediees) + "&";
        if (exclureAnnulees === null)
            throw new globalThis.Error("The parameter 'exclureAnnulees' cannot be null.");
        else if (exclureAnnulees !== undefined)
            url_ += "exclureAnnulees=" + encodeURIComponent("" + exclureAnnulees) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObtenirDpesTriesParPriorite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObtenirDpesTriesParPriorite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchDemandeExpeditionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchDemandeExpeditionDto[]>;
        }));
    }

    protected processObtenirDpesTriesParPriorite(response: HttpResponseBase): Observable<SearchDemandeExpeditionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SearchDemandeExpeditionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Modifie une DPE
     * @param body (optional) 
     * @return OK
     */
    modifierDpe(body: UpdateDemandeExpeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/DemandeExpedition/ModifierDpe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processModifierDpe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processModifierDpe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processModifierDpe(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Interrompt une DPE
     * @param dpeId (optional) 
     * @param interruptionId (optional) 
     * @param commentaire (optional) 
     * @return OK
     */
    interrompreDpe(dpeId: number | undefined, interruptionId: number | undefined, commentaire: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/DemandeExpedition/InterrompreDpe?";
        if (dpeId === null)
            throw new globalThis.Error("The parameter 'dpeId' cannot be null.");
        else if (dpeId !== undefined)
            url_ += "dpeId=" + encodeURIComponent("" + dpeId) + "&";
        if (interruptionId === null)
            throw new globalThis.Error("The parameter 'interruptionId' cannot be null.");
        else if (interruptionId !== undefined)
            url_ += "interruptionId=" + encodeURIComponent("" + interruptionId) + "&";
        if (commentaire === null)
            throw new globalThis.Error("The parameter 'commentaire' cannot be null.");
        else if (commentaire !== undefined)
            url_ += "commentaire=" + encodeURIComponent("" + commentaire) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInterrompreDpe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInterrompreDpe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInterrompreDpe(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Annuler une DPE
     * @param id (optional) 
     * @return OK
     */
    annulerDpe(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/DemandeExpedition/AnnulerDpe?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAnnulerDpe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAnnulerDpe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAnnulerDpe(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reprend une DPE
     * @param id (optional) 
     * @return OK
     */
    reprendreDpe(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/DemandeExpedition/ReprendreDpe?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReprendreDpe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReprendreDpe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReprendreDpe(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Recherche dpe pour preparation magasinier
    dpe - liste tags - liste pieces
     * @param dpeId (optional) 
     * @return OK
     */
    obtenirDpePourPreparation(dpeId: number | undefined): Observable<SearchDemandeExpeditionForPairingColisDto> {
        let url_ = this.baseUrl + "/api/DemandeExpedition/ObtenirDpePourPreparation?";
        if (dpeId === null)
            throw new globalThis.Error("The parameter 'dpeId' cannot be null.");
        else if (dpeId !== undefined)
            url_ += "dpeId=" + encodeURIComponent("" + dpeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObtenirDpePourPreparation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObtenirDpePourPreparation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchDemandeExpeditionForPairingColisDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchDemandeExpeditionForPairingColisDto>;
        }));
    }

    protected processObtenirDpePourPreparation(response: HttpResponseBase): Observable<SearchDemandeExpeditionForPairingColisDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchDemandeExpeditionForPairingColisDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Recherche dpe pour appairer un colis (obsolete on ne check plus lors des étapes de validations)
    dpe - liste tags - liste pieces
     * @param dpeId (optional) 
     * @return OK
     * @deprecated
     */
    dpeModifieeParSap(dpeId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/DemandeExpedition/DpeModifieeParSap?";
        if (dpeId === null)
            throw new globalThis.Error("The parameter 'dpeId' cannot be null.");
        else if (dpeId !== undefined)
            url_ += "dpeId=" + encodeURIComponent("" + dpeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDpeModifieeParSap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDpeModifieeParSap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDpeModifieeParSap(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Recherche dpe pour appairer un colis
    dpe - liste tags - liste pieces
     * @param dpeId (optional) 
     * @return OK
     */
    obtenirDpePourColisage(dpeId: number | undefined): Observable<SearchDemandeExpeditionForPairingColisDto> {
        let url_ = this.baseUrl + "/api/DemandeExpedition/ObtenirDpePourColisage?";
        if (dpeId === null)
            throw new globalThis.Error("The parameter 'dpeId' cannot be null.");
        else if (dpeId !== undefined)
            url_ += "dpeId=" + encodeURIComponent("" + dpeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObtenirDpePourColisage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObtenirDpePourColisage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchDemandeExpeditionForPairingColisDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchDemandeExpeditionForPairingColisDto>;
        }));
    }

    protected processObtenirDpePourColisage(response: HttpResponseBase): Observable<SearchDemandeExpeditionForPairingColisDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchDemandeExpeditionForPairingColisDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Recherche dpe pour chargement
    dpe (et c'est tout)
     * @param dpeId (optional) 
     * @return OK
     */
    obtenirDpePourChargement(dpeId: number | undefined): Observable<SearchDemandeExpeditionForLoadingDto> {
        let url_ = this.baseUrl + "/api/DemandeExpedition/ObtenirDpePourChargement?";
        if (dpeId === null)
            throw new globalThis.Error("The parameter 'dpeId' cannot be null.");
        else if (dpeId !== undefined)
            url_ += "dpeId=" + encodeURIComponent("" + dpeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObtenirDpePourChargement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObtenirDpePourChargement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchDemandeExpeditionForLoadingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchDemandeExpeditionForLoadingDto>;
        }));
    }

    protected processObtenirDpePourChargement(response: HttpResponseBase): Observable<SearchDemandeExpeditionForLoadingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchDemandeExpeditionForLoadingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Recherche une pièce via son numéro de série et son dpe Id
     * @param numeroSerie (optional) 
     * @param dpeId (optional) 
     * @return OK
     */
    rechercherPieceDpeParNumeroSerie(numeroSerie: string | undefined, dpeId: number | undefined): Observable<PairingPieceDto> {
        let url_ = this.baseUrl + "/api/DemandeExpedition/RechercherPieceDpeParNumeroSerie?";
        if (numeroSerie === null)
            throw new globalThis.Error("The parameter 'numeroSerie' cannot be null.");
        else if (numeroSerie !== undefined)
            url_ += "numeroSerie=" + encodeURIComponent("" + numeroSerie) + "&";
        if (dpeId === null)
            throw new globalThis.Error("The parameter 'dpeId' cannot be null.");
        else if (dpeId !== undefined)
            url_ += "dpeId=" + encodeURIComponent("" + dpeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRechercherPieceDpeParNumeroSerie(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRechercherPieceDpeParNumeroSerie(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PairingPieceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PairingPieceDto>;
        }));
    }

    protected processRechercherPieceDpeParNumeroSerie(response: HttpResponseBase): Observable<PairingPieceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PairingPieceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Valider emballage DPE
     * @param dpeId (optional) 
     * @return OK
     */
    validerEmballageDpe(dpeId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/DemandeExpedition/ValiderEmballageDpe?";
        if (dpeId === null)
            throw new globalThis.Error("The parameter 'dpeId' cannot be null.");
        else if (dpeId !== undefined)
            url_ += "dpeId=" + encodeURIComponent("" + dpeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValiderEmballageDpe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValiderEmballageDpe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValiderEmballageDpe(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Valider emballage à reprendre DPE
     * @param dpeId (optional) 
     * @return OK
     */
    validerEmballageAReprendreDpe(dpeId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/DemandeExpedition/ValiderEmballageAReprendreDpe?";
        if (dpeId === null)
            throw new globalThis.Error("The parameter 'dpeId' cannot be null.");
        else if (dpeId !== undefined)
            url_ += "dpeId=" + encodeURIComponent("" + dpeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValiderEmballageAReprendreDpe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValiderEmballageAReprendreDpe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValiderEmballageAReprendreDpe(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Valider chargement
     * @param dpeId (optional) 
     * @return OK
     */
    validerChargementDpe(dpeId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/DemandeExpedition/ValiderChargementDpe?";
        if (dpeId === null)
            throw new globalThis.Error("The parameter 'dpeId' cannot be null.");
        else if (dpeId !== undefined)
            url_ += "dpeId=" + encodeURIComponent("" + dpeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValiderChargementDpe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValiderChargementDpe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValiderChargementDpe(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Valider preparation DPE
     * @param dpeId (optional) 
     * @return OK
     */
    validerPreparationDpe(dpeId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/DemandeExpedition/ValiderPreparationDpe?";
        if (dpeId === null)
            throw new globalThis.Error("The parameter 'dpeId' cannot be null.");
        else if (dpeId !== undefined)
            url_ += "dpeId=" + encodeURIComponent("" + dpeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValiderPreparationDpe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValiderPreparationDpe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValiderPreparationDpe(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Recherche les dpes "dispo emballage" pour le module "emballer avec"
    par ressource/article, client et adresse livraison
     * @param codeArticle (optional) 
     * @param clientLivre (optional) 
     * @param adresseClientLivre (optional) 
     * @return OK
     */
    obtenirDpesDispoPourEmballeAvec(codeArticle: string | undefined, clientLivre: string | undefined, adresseClientLivre: string | undefined): Observable<SearchDemandeExpeditionForPairingColisDto[]> {
        let url_ = this.baseUrl + "/api/DemandeExpedition/ObtenirDpesDispoPourEmballeAvec?";
        if (codeArticle === null)
            throw new globalThis.Error("The parameter 'codeArticle' cannot be null.");
        else if (codeArticle !== undefined)
            url_ += "codeArticle=" + encodeURIComponent("" + codeArticle) + "&";
        if (clientLivre === null)
            throw new globalThis.Error("The parameter 'clientLivre' cannot be null.");
        else if (clientLivre !== undefined)
            url_ += "clientLivre=" + encodeURIComponent("" + clientLivre) + "&";
        if (adresseClientLivre === null)
            throw new globalThis.Error("The parameter 'adresseClientLivre' cannot be null.");
        else if (adresseClientLivre !== undefined)
            url_ += "adresseClientLivre=" + encodeURIComponent("" + adresseClientLivre) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObtenirDpesDispoPourEmballeAvec(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObtenirDpesDispoPourEmballeAvec(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchDemandeExpeditionForPairingColisDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchDemandeExpeditionForPairingColisDto[]>;
        }));
    }

    protected processObtenirDpesDispoPourEmballeAvec(response: HttpResponseBase): Observable<SearchDemandeExpeditionForPairingColisDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SearchDemandeExpeditionForPairingColisDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DemandeTransportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retourne tous les demandes de transport à traiter
     * @return OK
     */
    obtenirDemandesATraiter(): Observable<DemandeTransportDto[]> {
        let url_ = this.baseUrl + "/api/DemandeTransport/ObtenirDemandesATraiter";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObtenirDemandesATraiter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObtenirDemandesATraiter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DemandeTransportDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DemandeTransportDto[]>;
        }));
    }

    protected processObtenirDemandesATraiter(response: HttpResponseBase): Observable<DemandeTransportDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DemandeTransportDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retourne une demande de transport via son id
     * @return OK
     */
    obtenirDemandeTransportParId(id: number): Observable<DemandeTransportDto> {
        let url_ = this.baseUrl + "/api/DemandeTransport/ObtenirDemandeTransportParId/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObtenirDemandeTransportParId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObtenirDemandeTransportParId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DemandeTransportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DemandeTransportDto>;
        }));
    }

    protected processObtenirDemandeTransportParId(response: HttpResponseBase): Observable<DemandeTransportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DemandeTransportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Met à jour une demande
     * @param body (optional) 
     * @return Created
     */
    modifierDemandeTransport(body: TraiteDemandeTransportDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/DemandeTransport/ModifierDemandeTransport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processModifierDemandeTransport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processModifierDemandeTransport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processModifierDemandeTransport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class IntegrationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateContentOfIncomingMessage(body: IncomingMessageFullDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Integration/UpdateContentOfIncomingMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateContentOfIncomingMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateContentOfIncomingMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateContentOfIncomingMessage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyWord (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param inErrorOnly (optional) 
     * @return OK
     */
    getIncomingMessagesFiltered(keyWord: string | undefined, startDate: dayjs.Dayjs | undefined, endDate: dayjs.Dayjs | undefined, inErrorOnly: boolean | undefined): Observable<IncomingMessageDto[]> {
        let url_ = this.baseUrl + "/api/Integration/GetIncomingMessagesFiltered?";
        if (keyWord === null)
            throw new globalThis.Error("The parameter 'keyWord' cannot be null.");
        else if (keyWord !== undefined)
            url_ += "keyWord=" + encodeURIComponent("" + keyWord) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (inErrorOnly === null)
            throw new globalThis.Error("The parameter 'inErrorOnly' cannot be null.");
        else if (inErrorOnly !== undefined)
            url_ += "inErrorOnly=" + encodeURIComponent("" + inErrorOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncomingMessagesFiltered(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncomingMessagesFiltered(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IncomingMessageDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IncomingMessageDto[]>;
        }));
    }

    protected processGetIncomingMessagesFiltered(response: HttpResponseBase): Observable<IncomingMessageDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IncomingMessageDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getIncomingMessageById(id: number): Observable<IncomingMessageFullDto> {
        let url_ = this.baseUrl + "/api/Integration/GetIncomingMessageById/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncomingMessageById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncomingMessageById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IncomingMessageFullDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IncomingMessageFullDto>;
        }));
    }

    protected processGetIncomingMessageById(response: HttpResponseBase): Observable<IncomingMessageFullDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IncomingMessageFullDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    play(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Integration/Play/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPlay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPlay(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPlay(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class InterruptionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retourne la liste des interruptions
     * @return OK
     */
    getInterruptions(): Observable<InterruptionDto[]> {
        let url_ = this.baseUrl + "/api/Interruption/GetInterruptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInterruptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInterruptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InterruptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InterruptionDto[]>;
        }));
    }

    protected processGetInterruptions(response: HttpResponseBase): Observable<InterruptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InterruptionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retourne une interruption via l'id passé
     * @return OK
     */
    getInterruptionById(id: number): Observable<InterruptionDto> {
        let url_ = this.baseUrl + "/api/Interruption/GetInterruptionById/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInterruptionById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInterruptionById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InterruptionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InterruptionDto>;
        }));
    }

    protected processGetInterruptionById(response: HttpResponseBase): Observable<InterruptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InterruptionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Créé une interruption
     * @param body (optional) 
     * @return OK
     */
    creerInterruption(body: InterruptionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Interruption/CreerInterruption";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreerInterruption(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreerInterruption(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreerInterruption(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Met à jour une interruption
     * @param body (optional) 
     * @return Created
     */
    update(body: InterruptionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Interruption/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Supprime une interruption
     * @return OK
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Interruption/Delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LocalisationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Récupère toutes les zones
     * @return OK
     */
    obtenirZones(): Observable<ZoneDto[]> {
        let url_ = this.baseUrl + "/api/Localisation/ObtenirZones";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObtenirZones(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObtenirZones(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZoneDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZoneDto[]>;
        }));
    }

    protected processObtenirZones(response: HttpResponseBase): Observable<ZoneDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ZoneDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Récupère toutes les pièces avec les positions associées
     * @return OK
     */
    obtenirPiecesAvecPositions(): Observable<PieceDto[]> {
        let url_ = this.baseUrl + "/api/Localisation/ObtenirPiecesAvecPositions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObtenirPiecesAvecPositions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObtenirPiecesAvecPositions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PieceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PieceDto[]>;
        }));
    }

    protected processObtenirPiecesAvecPositions(response: HttpResponseBase): Observable<PieceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PieceDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NotificationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getNotifications(): Observable<NotificationDto[]> {
        let url_ = this.baseUrl + "/api/Notification/GetNotifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationDto[]>;
        }));
    }

    protected processGetNotifications(response: HttpResponseBase): Observable<NotificationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotificationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getNotificationById(id: number | undefined): Observable<DetailNotificationDto> {
        let url_ = this.baseUrl + "/api/Notification/GetNotificationById?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotificationById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotificationById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DetailNotificationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DetailNotificationDto>;
        }));
    }

    protected processGetNotificationById(response: HttpResponseBase): Observable<DetailNotificationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DetailNotificationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Notification/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    deleteNotificationMessage(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Notification/DeleteNotificationMessage/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteNotificationMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteNotificationMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteNotificationMessage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    update(body: DetailNotificationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Notification/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    marquerCommeLus(body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Notification/MarquerCommeLus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarquerCommeLus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarquerCommeLus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMarquerCommeLus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body: DetailNotificationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Notification/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    rechercherTypeNotifications(): Observable<NotificationTypeDto[]> {
        let url_ = this.baseUrl + "/api/Notification/RechercherTypeNotifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRechercherTypeNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRechercherTypeNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationTypeDto[]>;
        }));
    }

    protected processRechercherTypeNotifications(response: HttpResponseBase): Observable<NotificationTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotificationTypeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    rechercherSenders(): Observable<NotificationSenderDto[]> {
        let url_ = this.baseUrl + "/api/Notification/RechercherSenders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRechercherSenders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRechercherSenders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationSenderDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationSenderDto[]>;
        }));
    }

    protected processRechercherSenders(response: HttpResponseBase): Observable<NotificationSenderDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotificationSenderDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    rechercherMessagesUtilisateur(userId: number): Observable<NotificationMessageDto[]> {
        let url_ = this.baseUrl + "/api/Notification/RechercherMessagesUtilisateur/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRechercherMessagesUtilisateur(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRechercherMessagesUtilisateur(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationMessageDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationMessageDto[]>;
        }));
    }

    protected processRechercherMessagesUtilisateur(response: HttpResponseBase): Observable<NotificationMessageDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotificationMessageDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return OK
     */
    filtrerMessagesParDate(startDate: dayjs.Dayjs | undefined, endDate: dayjs.Dayjs | undefined): Observable<NotificationMessageDto[]> {
        let url_ = this.baseUrl + "/api/Notification/FiltrerMessagesParDate?";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFiltrerMessagesParDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFiltrerMessagesParDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationMessageDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationMessageDto[]>;
        }));
    }

    protected processFiltrerMessagesParDate(response: HttpResponseBase): Observable<NotificationMessageDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotificationMessageDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    rechercherNombreMessagesNonLus(userId: number): Observable<number> {
        let url_ = this.baseUrl + "/api/Notification/RechercherNombreMessagesNonLus/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRechercherNombreMessagesNonLus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRechercherNombreMessagesNonLus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processRechercherNombreMessagesNonLus(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    rechercherMessageLecture(id: number | undefined): Observable<NotificationMessageDto> {
        let url_ = this.baseUrl + "/api/Notification/RechercherMessageLecture?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRechercherMessageLecture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRechercherMessageLecture(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationMessageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationMessageDto>;
        }));
    }

    protected processRechercherMessageLecture(response: HttpResponseBase): Observable<NotificationMessageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationMessageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    rechercherMessagesNonLus(userId: number): Observable<NotificationMessageDto[]> {
        let url_ = this.baseUrl + "/api/Notification/RechercherMessagesNonLus/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRechercherMessagesNonLus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRechercherMessagesNonLus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationMessageDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationMessageDto[]>;
        }));
    }

    protected processRechercherMessagesNonLus(response: HttpResponseBase): Observable<NotificationMessageDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotificationMessageDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param messageId (optional) 
     * @return OK
     */
    envoyerMessage(messageId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Notification/EnvoyerMessage?";
        if (messageId === null)
            throw new globalThis.Error("The parameter 'messageId' cannot be null.");
        else if (messageId !== undefined)
            url_ += "messageId=" + encodeURIComponent("" + messageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnvoyerMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnvoyerMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEnvoyerMessage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OutgoingClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateContentOfIncomingMessage(body: OutgoingMessageFullDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Outgoing/UpdateContentOfIncomingMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateContentOfIncomingMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateContentOfIncomingMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateContentOfIncomingMessage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyWord (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param inErrorOnly (optional) 
     * @return OK
     */
    getOutgoingMessagesFiltered(keyWord: string | undefined, startDate: dayjs.Dayjs | undefined, endDate: dayjs.Dayjs | undefined, inErrorOnly: boolean | undefined): Observable<OutgoingMessageDto[]> {
        let url_ = this.baseUrl + "/api/Outgoing/GetOutgoingMessagesFiltered?";
        if (keyWord === null)
            throw new globalThis.Error("The parameter 'keyWord' cannot be null.");
        else if (keyWord !== undefined)
            url_ += "keyWord=" + encodeURIComponent("" + keyWord) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (inErrorOnly === null)
            throw new globalThis.Error("The parameter 'inErrorOnly' cannot be null.");
        else if (inErrorOnly !== undefined)
            url_ += "inErrorOnly=" + encodeURIComponent("" + inErrorOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOutgoingMessagesFiltered(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOutgoingMessagesFiltered(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OutgoingMessageDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OutgoingMessageDto[]>;
        }));
    }

    protected processGetOutgoingMessagesFiltered(response: HttpResponseBase): Observable<OutgoingMessageDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OutgoingMessageDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getOutgoingMessageById(id: number): Observable<OutgoingMessageFullDto> {
        let url_ = this.baseUrl + "/api/Outgoing/GetOutgoingMessageById/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOutgoingMessageById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOutgoingMessageById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OutgoingMessageFullDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OutgoingMessageFullDto>;
        }));
    }

    protected processGetOutgoingMessageById(response: HttpResponseBase): Observable<OutgoingMessageFullDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OutgoingMessageFullDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    play(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Outgoing/Play/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPlay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPlay(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPlay(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PieceClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Recherche les pièces en passant une list de string et un type de recherche (0: Pièce, 10: OF, 20: Tag)
     * @param typeRecherche (optional) 
     * @param body (optional) 
     * @return OK
     */
    rechercherPieces(typeRecherche: ETypeRecherche | undefined, body: string[] | undefined): Observable<GroupePiecesDto[]> {
        let url_ = this.baseUrl + "/api/Piece/RechercherPieces?";
        if (typeRecherche === null)
            throw new globalThis.Error("The parameter 'typeRecherche' cannot be null.");
        else if (typeRecherche !== undefined)
            url_ += "typeRecherche=" + encodeURIComponent("" + typeRecherche) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRechercherPieces(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRechercherPieces(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GroupePiecesDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GroupePiecesDto[]>;
        }));
    }

    protected processRechercherPieces(response: HttpResponseBase): Observable<GroupePiecesDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GroupePiecesDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Recherche les pièces appairées à un tag
     * @param tagId (optional) 
     * @return OK
     */
    rechercherPiecesAppairerTag(tagId: number | undefined): Observable<SearchPieceDto[]> {
        let url_ = this.baseUrl + "/api/Piece/RechercherPiecesAppairerTag?";
        if (tagId === null)
            throw new globalThis.Error("The parameter 'tagId' cannot be null.");
        else if (tagId !== undefined)
            url_ += "tagId=" + encodeURIComponent("" + tagId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRechercherPiecesAppairerTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRechercherPiecesAppairerTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchPieceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchPieceDto[]>;
        }));
    }

    protected processRechercherPiecesAppairerTag(response: HttpResponseBase): Observable<SearchPieceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SearchPieceDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Appaire une pièce à un tag en passant un pieceId et un tagId
     * @param body (optional) 
     * @return OK
     */
    appairerPiece(body: PairingTagDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Piece/AppairerPiece";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppairerPiece(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppairerPiece(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAppairerPiece(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Desappaire une ou des pièces à un tag
     * @param commentaireId (optional) 
     * @param body (optional) 
     * @return OK
     */
    desappairerPieces(commentaireId: number | undefined, body: PairingTagDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Piece/DesappairerPieces?";
        if (commentaireId === null)
            throw new globalThis.Error("The parameter 'commentaireId' cannot be null.");
        else if (commentaireId !== undefined)
            url_ += "commentaireId=" + encodeURIComponent("" + commentaireId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDesappairerPieces(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDesappairerPieces(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDesappairerPieces(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Recherche une pièce et instancie une nouvelle instance sans la créer si elle n'existe pas
     * @param numeroSerie (optional) 
     * @return OK
     */
    rechercherOuRenvoyerNouvellePiece(numeroSerie: string | undefined): Observable<SearchPieceDto> {
        let url_ = this.baseUrl + "/api/Piece/RechercherOuRenvoyerNouvellePiece?";
        if (numeroSerie === null)
            throw new globalThis.Error("The parameter 'numeroSerie' cannot be null.");
        else if (numeroSerie !== undefined)
            url_ += "numeroSerie=" + encodeURIComponent("" + numeroSerie) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRechercherOuRenvoyerNouvellePiece(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRechercherOuRenvoyerNouvellePiece(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchPieceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchPieceDto>;
        }));
    }

    protected processRechercherOuRenvoyerNouvellePiece(response: HttpResponseBase): Observable<SearchPieceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchPieceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Recherche une pièce avec le tag appairé
     * @param numeroSerie (optional) 
     * @return OK
     */
    rechercherPieceAvecTag(numeroSerie: string | undefined): Observable<MovePairingPieceDto> {
        let url_ = this.baseUrl + "/api/Piece/RechercherPieceAvecTag?";
        if (numeroSerie === null)
            throw new globalThis.Error("The parameter 'numeroSerie' cannot be null.");
        else if (numeroSerie !== undefined)
            url_ += "numeroSerie=" + encodeURIComponent("" + numeroSerie) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRechercherPieceAvecTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRechercherPieceAvecTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MovePairingPieceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MovePairingPieceDto>;
        }));
    }

    protected processRechercherPieceAvecTag(response: HttpResponseBase): Observable<MovePairingPieceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MovePairingPieceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Modifie l'appairage de plusieurs pièces pour un tag id donné
     * @param body (optional) 
     * @return OK
     */
    modifierAppairage(body: UpdatePairingDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Piece/ModifierAppairage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processModifierAppairage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processModifierAppairage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processModifierAppairage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Recherche les pièces appairées à une DPE
     * @param dpeId (optional) 
     * @return OK
     */
    rechercherPiecesAppairerDPE(dpeId: number | undefined): Observable<SearchPieceDto[]> {
        let url_ = this.baseUrl + "/api/Piece/RechercherPiecesAppairerDPE?";
        if (dpeId === null)
            throw new globalThis.Error("The parameter 'dpeId' cannot be null.");
        else if (dpeId !== undefined)
            url_ += "dpeId=" + encodeURIComponent("" + dpeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRechercherPiecesAppairerDPE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRechercherPiecesAppairerDPE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchPieceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchPieceDto[]>;
        }));
    }

    protected processRechercherPiecesAppairerDPE(response: HttpResponseBase): Observable<SearchPieceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SearchPieceDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Recherche les pièces à déplacer : 
    anomalies > stock,
    stock > anomalies,
    rebus
     * @return OK
     */
    rechercherPiecesDeplacer(): Observable<SearchPieceDto[]> {
        let url_ = this.baseUrl + "/api/Piece/RechercherPiecesDeplacer";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRechercherPiecesDeplacer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRechercherPiecesDeplacer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchPieceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchPieceDto[]>;
        }));
    }

    protected processRechercherPiecesDeplacer(response: HttpResponseBase): Observable<SearchPieceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SearchPieceDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Recherche les pièces en anomalie qui ne sont pas en zone de quarantaine
     * @return OK
     */
    rechercherPiecesAnomalie(): Observable<SearchPieceDto[]> {
        let url_ = this.baseUrl + "/api/Piece/RechercherPiecesAnomalie";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRechercherPiecesAnomalie(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRechercherPiecesAnomalie(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchPieceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchPieceDto[]>;
        }));
    }

    protected processRechercherPiecesAnomalie(response: HttpResponseBase): Observable<SearchPieceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SearchPieceDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Recherche les pièces dans une zone de quarantaine qui ne sont pas en anomalies
     * @return OK
     */
    rechercherPiecesEnQuarantaine(): Observable<SearchPieceDto[]> {
        let url_ = this.baseUrl + "/api/Piece/RechercherPiecesEnQuarantaine";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRechercherPiecesEnQuarantaine(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRechercherPiecesEnQuarantaine(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchPieceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchPieceDto[]>;
        }));
    }

    protected processRechercherPiecesEnQuarantaine(response: HttpResponseBase): Observable<SearchPieceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SearchPieceDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PriorisationParametrageClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Recherche les priorisations client
     * @return OK
     */
    obtenirPriorisations(): Observable<SearchPriorisationParametrageDto[]> {
        let url_ = this.baseUrl + "/api/PriorisationParametrage/ObtenirPriorisations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObtenirPriorisations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObtenirPriorisations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchPriorisationParametrageDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchPriorisationParametrageDto[]>;
        }));
    }

    protected processObtenirPriorisations(response: HttpResponseBase): Observable<SearchPriorisationParametrageDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SearchPriorisationParametrageDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * créée une priorisation client
     * @param body (optional) 
     * @return OK
     */
    creerPriorisation(body: NewPriorisationParametrageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/PriorisationParametrage/CreerPriorisation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreerPriorisation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreerPriorisation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreerPriorisation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Modifie une priorisation client
     * @param body (optional) 
     * @return OK
     */
    modifierPriorisation(body: EditPriorisationParametrageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/PriorisationParametrage/ModifierPriorisation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processModifierPriorisation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processModifierPriorisation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processModifierPriorisation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Obtient une priorisation client par Id
     * @param idPrio (optional) 
     * @return OK
     */
    obtenirPriorisation(idPrio: number | undefined): Observable<SearchPriorisationParametrageDto> {
        let url_ = this.baseUrl + "/api/PriorisationParametrage/ObtenirPriorisation?";
        if (idPrio === null)
            throw new globalThis.Error("The parameter 'idPrio' cannot be null.");
        else if (idPrio !== undefined)
            url_ += "idPrio=" + encodeURIComponent("" + idPrio) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObtenirPriorisation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObtenirPriorisation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchPriorisationParametrageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchPriorisationParametrageDto>;
        }));
    }

    protected processObtenirPriorisation(response: HttpResponseBase): Observable<SearchPriorisationParametrageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchPriorisationParametrageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Supprimer une priorisation client par Id
     * @param idPrio (optional) 
     * @return OK
     */
    supprimerPriorisation(idPrio: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/PriorisationParametrage/SupprimerPriorisation?";
        if (idPrio === null)
            throw new globalThis.Error("The parameter 'idPrio' cannot be null.");
        else if (idPrio !== undefined)
            url_ += "idPrio=" + encodeURIComponent("" + idPrio) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSupprimerPriorisation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSupprimerPriorisation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSupprimerPriorisation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RoleClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getClaims(): Observable<ArrayClaimDto[]> {
        let url_ = this.baseUrl + "/api/Role/GetClaims";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClaims(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClaims(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArrayClaimDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArrayClaimDto[]>;
        }));
    }

    protected processGetClaims(response: HttpResponseBase): Observable<ArrayClaimDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ArrayClaimDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getRoles(): Observable<SAMRoleDto[]> {
        let url_ = this.baseUrl + "/api/Role/GetRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SAMRoleDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SAMRoleDto[]>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<SAMRoleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SAMRoleDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getRoleById(id: number): Observable<SAMRoleDto> {
        let url_ = this.baseUrl + "/api/Role/GetRoleById/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SAMRoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SAMRoleDto>;
        }));
    }

    protected processGetRoleById(response: HttpResponseBase): Observable<SAMRoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SAMRoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body: SAMRoleDto | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/Role/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    update(id: number, body: SAMRoleDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Role/Update/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Role/Delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SAMClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getAssembly(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/SAM/GetAssembly";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssembly(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssembly(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAssembly(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getSampleMessage(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/SAM/GetSampleMessage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSampleMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSampleMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetSampleMessage(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SAMHealthCheckClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    checkHealth(): Observable<void> {
        let url_ = this.baseUrl + "/api/SAMHealthCheck/CheckHealth";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckHealth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckHealth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCheckHealth(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ScheduledTaskClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getScheduledTasks(): Observable<ScheduledTaskDto[]> {
        let url_ = this.baseUrl + "/api/ScheduledTask/GetScheduledTasks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetScheduledTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetScheduledTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduledTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduledTaskDto[]>;
        }));
    }

    protected processGetScheduledTasks(response: HttpResponseBase): Observable<ScheduledTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScheduledTaskDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body: ScheduledTaskDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ScheduledTask/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getById(id: number): Observable<ScheduledTaskDto> {
        let url_ = this.baseUrl + "/api/ScheduledTask/GetById/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduledTaskDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduledTaskDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<ScheduledTaskDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduledTaskDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    update(body: ScheduledTaskDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ScheduledTask/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/ScheduledTask/Delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    obtenirTypeMessages(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/ScheduledTask/ObtenirTypeMessages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObtenirTypeMessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObtenirTypeMessages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processObtenirTypeMessages(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SettingClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    rechercherSettingParNom(name: string): Observable<SettingDto> {
        let url_ = this.baseUrl + "/api/Setting/RechercherSettingParNom/{name}";
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRechercherSettingParNom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRechercherSettingParNom(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SettingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SettingDto>;
        }));
    }

    protected processRechercherSettingParNom(response: HttpResponseBase): Observable<SettingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SettingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    rechercherSettingsContenantNom(name: string): Observable<SettingDto[]> {
        let url_ = this.baseUrl + "/api/Setting/RechercherSettingsContenantNom/{name}";
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRechercherSettingsContenantNom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRechercherSettingsContenantNom(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SettingDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SettingDto[]>;
        }));
    }

    protected processRechercherSettingsContenantNom(response: HttpResponseBase): Observable<SettingDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SettingDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateSettings(body: SettingDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Setting/UpdateSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SignalrClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    backToClients(): Observable<void> {
        let url_ = this.baseUrl + "/api/Signalr/BackToClients";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBackToClients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBackToClients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBackToClients(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TagClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Recherche un tag et s'il n'existe pas instancie un nouveau tag sans le créer
     * @param tagIdentifier (optional) 
     * @return OK
     */
    rechercherOuRenvoyerNouveauTag(tagIdentifier: string | undefined): Observable<PairingTagDto> {
        let url_ = this.baseUrl + "/api/Tag/RechercherOuRenvoyerNouveauTag?";
        if (tagIdentifier === null)
            throw new globalThis.Error("The parameter 'tagIdentifier' cannot be null.");
        else if (tagIdentifier !== undefined)
            url_ += "tagIdentifier=" + encodeURIComponent("" + tagIdentifier) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRechercherOuRenvoyerNouveauTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRechercherOuRenvoyerNouveauTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PairingTagDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PairingTagDto>;
        }));
    }

    protected processRechercherOuRenvoyerNouveauTag(response: HttpResponseBase): Observable<PairingTagDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PairingTagDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tagName (optional) 
     * @return OK
     */
    checkTagNameIsValid(tagName: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Tag/CheckTagNameIsValid?";
        if (tagName === null)
            throw new globalThis.Error("The parameter 'tagName' cannot be null.");
        else if (tagName !== undefined)
            url_ += "tagName=" + encodeURIComponent("" + tagName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckTagNameIsValid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckTagNameIsValid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCheckTagNameIsValid(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Recherche les tags qui sont appairés à des pièces
     * @return OK
     */
    rechercherBalisesAppairerAvecPiece(): Observable<TagPairedDto[]> {
        let url_ = this.baseUrl + "/api/Tag/RechercherBalisesAppairerAvecPiece";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRechercherBalisesAppairerAvecPiece(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRechercherBalisesAppairerAvecPiece(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TagPairedDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TagPairedDto[]>;
        }));
    }

    protected processRechercherBalisesAppairerAvecPiece(response: HttpResponseBase): Observable<TagPairedDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TagPairedDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Recherche un tag pour le désappairage (ne créé pas d'instance vide)
     * @param tagIdentifier (optional) 
     * @return OK
     */
    rechercherTagDesappairage(tagIdentifier: string | undefined): Observable<PairingTagDto> {
        let url_ = this.baseUrl + "/api/Tag/RechercherTagDesappairage?";
        if (tagIdentifier === null)
            throw new globalThis.Error("The parameter 'tagIdentifier' cannot be null.");
        else if (tagIdentifier !== undefined)
            url_ += "tagIdentifier=" + encodeURIComponent("" + tagIdentifier) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRechercherTagDesappairage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRechercherTagDesappairage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PairingTagDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PairingTagDto>;
        }));
    }

    protected processRechercherTagDesappairage(response: HttpResponseBase): Observable<PairingTagDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PairingTagDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Créé un Tag
     * @param tagIdentifier (optional) 
     * @param latitude (optional) 
     * @param longitude (optional) 
     * @param altitude (optional) 
     * @return OK
     */
    creerTag(tagIdentifier: string | undefined, latitude: number | undefined, longitude: number | undefined, altitude: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Tag/CreerTag?";
        if (tagIdentifier === null)
            throw new globalThis.Error("The parameter 'tagIdentifier' cannot be null.");
        else if (tagIdentifier !== undefined)
            url_ += "tagIdentifier=" + encodeURIComponent("" + tagIdentifier) + "&";
        if (latitude === null)
            throw new globalThis.Error("The parameter 'latitude' cannot be null.");
        else if (latitude !== undefined)
            url_ += "latitude=" + encodeURIComponent("" + latitude) + "&";
        if (longitude === null)
            throw new globalThis.Error("The parameter 'longitude' cannot be null.");
        else if (longitude !== undefined)
            url_ += "longitude=" + encodeURIComponent("" + longitude) + "&";
        if (altitude === null)
            throw new globalThis.Error("The parameter 'altitude' cannot be null.");
        else if (altitude !== undefined)
            url_ += "altitude=" + encodeURIComponent("" + altitude) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreerTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreerTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreerTag(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Modifie la position d'un Tag et de ses pieces appairées
     * @param tagIdentifier (optional) 
     * @param latitude (optional) 
     * @param longitude (optional) 
     * @param altitude (optional) 
     * @return OK
     */
    modifierPositionTag(tagIdentifier: string | undefined, latitude: number | undefined, longitude: number | undefined, altitude: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Tag/ModifierPositionTag?";
        if (tagIdentifier === null)
            throw new globalThis.Error("The parameter 'tagIdentifier' cannot be null.");
        else if (tagIdentifier !== undefined)
            url_ += "tagIdentifier=" + encodeURIComponent("" + tagIdentifier) + "&";
        if (latitude === null)
            throw new globalThis.Error("The parameter 'latitude' cannot be null.");
        else if (latitude !== undefined)
            url_ += "latitude=" + encodeURIComponent("" + latitude) + "&";
        if (longitude === null)
            throw new globalThis.Error("The parameter 'longitude' cannot be null.");
        else if (longitude !== undefined)
            url_ += "longitude=" + encodeURIComponent("" + longitude) + "&";
        if (altitude === null)
            throw new globalThis.Error("The parameter 'altitude' cannot be null.");
        else if (altitude !== undefined)
            url_ += "altitude=" + encodeURIComponent("" + altitude) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processModifierPositionTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processModifierPositionTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processModifierPositionTag(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Récupère les infos du module touareg
     * @param touaregUid (optional) 
     * @return OK
     */
    obtenirTouareg(touaregUid: number | undefined): Observable<TouaregDto> {
        let url_ = this.baseUrl + "/api/Tag/ObtenirTouareg?";
        if (touaregUid === null)
            throw new globalThis.Error("The parameter 'touaregUid' cannot be null.");
        else if (touaregUid !== undefined)
            url_ += "touaregUid=" + encodeURIComponent("" + touaregUid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObtenirTouareg(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObtenirTouareg(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TouaregDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TouaregDto>;
        }));
    }

    protected processObtenirTouareg(response: HttpResponseBase): Observable<TouaregDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TouaregDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Créer une action operateur sur le BFS Touareg (/touareg_operator_action)
     * @param body (optional) 
     * @return OK
     */
    creerTouaregActionOperateur(body: TouaregOperatorActionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Tag/CreerTouaregActionOperateur";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreerTouaregActionOperateur(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreerTouaregActionOperateur(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreerTouaregActionOperateur(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    checkLogin(body: SAMUserDto | undefined): Observable<SAMUserDto> {
        let url_ = this.baseUrl + "/api/User/CheckLogin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SAMUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SAMUserDto>;
        }));
    }

    protected processCheckLogin(response: HttpResponseBase): Observable<SAMUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SAMUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getUsers(): Observable<SAMUserDto[]> {
        let url_ = this.baseUrl + "/api/User/GetUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SAMUserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SAMUserDto[]>;
        }));
    }

    protected processGetUsers(response: HttpResponseBase): Observable<SAMUserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SAMUserDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getCurrentUserRoles(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/User/GetCurrentUserRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentUserRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUserRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetCurrentUserRoles(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getRolesByUserId(id: number | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/User/GetRolesByUserId?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRolesByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRolesByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetRolesByUserId(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    register(body: SAMUserDto | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/User/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getUserById(id: number): Observable<SAMUserDto> {
        let url_ = this.baseUrl + "/api/User/GetUserById/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SAMUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SAMUserDto>;
        }));
    }

    protected processGetUserById(response: HttpResponseBase): Observable<SAMUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SAMUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/User/Delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    update(body: SAMUserDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/User/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ZoneClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getZones(): Observable<ZoneDto[]> {
        let url_ = this.baseUrl + "/api/Zone/GetZones";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetZones(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetZones(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZoneDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZoneDto[]>;
        }));
    }

    protected processGetZones(response: HttpResponseBase): Observable<ZoneDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ZoneDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retourne une zone via son id
     * @return OK
     */
    getZoneById(id: number): Observable<ZoneDto> {
        let url_ = this.baseUrl + "/api/Zone/GetZoneById/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetZoneById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetZoneById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZoneDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZoneDto>;
        }));
    }

    protected processGetZoneById(response: HttpResponseBase): Observable<ZoneDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZoneDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Supprime une zone par son id
     * @return OK
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Zone/Delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Met à jour une zone
     * @param body (optional) 
     * @return Created
     */
    update(body: ZoneDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Zone/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Créé une zone
     * @param body (optional) 
     * @return OK
     */
    create(body: ZoneDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Zone/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AnomalieDemandeTransportDto implements IAnomalieDemandeTransportDto {
    id?: number;
    demandeTransport?: LightDemandeTransportDto;
    demandeTransportId?: number;
    createdDate?: dayjs.Dayjs | undefined;

    constructor(data?: IAnomalieDemandeTransportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.demandeTransport = _data["demandeTransport"] ? LightDemandeTransportDto.fromJS(_data["demandeTransport"]) : undefined as any;
            this.demandeTransportId = _data["demandeTransportId"];
            this.createdDate = _data["createdDate"] ? dayjs(_data["createdDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AnomalieDemandeTransportDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnomalieDemandeTransportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["demandeTransport"] = this.demandeTransport ? this.demandeTransport.toJSON() : undefined as any;
        data["demandeTransportId"] = this.demandeTransportId;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IAnomalieDemandeTransportDto {
    id?: number;
    demandeTransport?: LightDemandeTransportDto;
    demandeTransportId?: number;
    createdDate?: dayjs.Dayjs | undefined;
}

export class ArrayClaimDto implements IArrayClaimDto {
    name?: string | undefined;
    children?: ArrayClaimDto[] | undefined;

    constructor(data?: IArrayClaimDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(ArrayClaimDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ArrayClaimDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArrayClaimDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IArrayClaimDto {
    name?: string | undefined;
    children?: ArrayClaimDto[] | undefined;
}

export class ArticleDto implements IArticleDto {
    id?: number;
    code?: string | undefined;
    libelle?: string | undefined;
    longueur?: number;
    largeur?: number;
    hauteur?: number;
    poidsTare?: number;
    gerbabilite?: ETypeGerbable;
    type?: ETypeArticle;

    constructor(data?: IArticleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.libelle = _data["libelle"];
            this.longueur = _data["longueur"];
            this.largeur = _data["largeur"];
            this.hauteur = _data["hauteur"];
            this.poidsTare = _data["poidsTare"];
            this.gerbabilite = _data["gerbabilite"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): ArticleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["libelle"] = this.libelle;
        data["longueur"] = this.longueur;
        data["largeur"] = this.largeur;
        data["hauteur"] = this.hauteur;
        data["poidsTare"] = this.poidsTare;
        data["gerbabilite"] = this.gerbabilite;
        data["type"] = this.type;
        return data;
    }
}

export interface IArticleDto {
    id?: number;
    code?: string | undefined;
    libelle?: string | undefined;
    longueur?: number;
    largeur?: number;
    hauteur?: number;
    poidsTare?: number;
    gerbabilite?: ETypeGerbable;
    type?: ETypeArticle;
}

export class CommentaireDto implements ICommentaireDto {
    id?: number;
    code?: string | undefined;

    constructor(data?: ICommentaireDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): CommentaireDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommentaireDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        return data;
    }
}

export interface ICommentaireDto {
    id?: number;
    code?: string | undefined;
}

export class DemandeApproTagDto implements IDemandeApproTagDto {
    id?: number;
    atelier?: string | undefined;
    statut?: EStatutDemandeApproTag;
    dateDemande?: dayjs.Dayjs | undefined;

    constructor(data?: IDemandeApproTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.atelier = _data["atelier"];
            this.statut = _data["statut"];
            this.dateDemande = _data["dateDemande"] ? dayjs(_data["dateDemande"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): DemandeApproTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new DemandeApproTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["atelier"] = this.atelier;
        data["statut"] = this.statut;
        data["dateDemande"] = this.dateDemande ? this.dateDemande.toISOString() : undefined as any;
        return data;
    }
}

export interface IDemandeApproTagDto {
    id?: number;
    atelier?: string | undefined;
    statut?: EStatutDemandeApproTag;
    dateDemande?: dayjs.Dayjs | undefined;
}

export class DemandeExpeditionEtiquetteDto implements IDemandeExpeditionEtiquetteDto {
    id?: number;
    numeroPDL?: string | undefined;
    codeArticle?: string | undefined;
    clientLivre?: string | undefined;
    pieces?: PieceEtiquetteDto[] | undefined;

    constructor(data?: IDemandeExpeditionEtiquetteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.numeroPDL = _data["numeroPDL"];
            this.codeArticle = _data["codeArticle"];
            this.clientLivre = _data["clientLivre"];
            if (Array.isArray(_data["pieces"])) {
                this.pieces = [] as any;
                for (let item of _data["pieces"])
                    this.pieces!.push(PieceEtiquetteDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DemandeExpeditionEtiquetteDto {
        data = typeof data === 'object' ? data : {};
        let result = new DemandeExpeditionEtiquetteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["numeroPDL"] = this.numeroPDL;
        data["codeArticle"] = this.codeArticle;
        data["clientLivre"] = this.clientLivre;
        if (Array.isArray(this.pieces)) {
            data["pieces"] = [];
            for (let item of this.pieces)
                data["pieces"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDemandeExpeditionEtiquetteDto {
    id?: number;
    numeroPDL?: string | undefined;
    codeArticle?: string | undefined;
    clientLivre?: string | undefined;
    pieces?: PieceEtiquetteDto[] | undefined;
}

export class DemandeTransportDto implements IDemandeTransportDto {
    id?: number;
    type?: ETypeDemandeTransport;
    piece?: PieceDemandeTransportDto;
    pieceId?: number;
    depuis?: string | undefined;
    vers?: string | undefined;
    traitee?: boolean;
    modifiedBy?: number | undefined;
    isAppaired?: boolean;

    constructor(data?: IDemandeTransportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.piece = _data["piece"] ? PieceDemandeTransportDto.fromJS(_data["piece"]) : undefined as any;
            this.pieceId = _data["pieceId"];
            this.depuis = _data["depuis"];
            this.vers = _data["vers"];
            this.traitee = _data["traitee"];
            this.modifiedBy = _data["modifiedBy"];
            this.isAppaired = _data["isAppaired"];
        }
    }

    static fromJS(data: any): DemandeTransportDto {
        data = typeof data === 'object' ? data : {};
        let result = new DemandeTransportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["piece"] = this.piece ? this.piece.toJSON() : undefined as any;
        data["pieceId"] = this.pieceId;
        data["depuis"] = this.depuis;
        data["vers"] = this.vers;
        data["traitee"] = this.traitee;
        data["modifiedBy"] = this.modifiedBy;
        data["isAppaired"] = this.isAppaired;
        return data;
    }
}

export interface IDemandeTransportDto {
    id?: number;
    type?: ETypeDemandeTransport;
    piece?: PieceDemandeTransportDto;
    pieceId?: number;
    depuis?: string | undefined;
    vers?: string | undefined;
    traitee?: boolean;
    modifiedBy?: number | undefined;
    isAppaired?: boolean;
}

export class DetailNotificationDto implements IDetailNotificationDto {
    id?: number;
    description?: string | undefined;
    type?: NotificationTypeDto;
    rolesIdToSendTo?: NotificationRoleDto[] | undefined;
    usersIdToSendTo?: NotificationUserDto[] | undefined;
    senders?: NotificationSenderDto[] | undefined;
    messageTemplate?: string | undefined;
    titleTemplate?: string | undefined;

    constructor(data?: IDetailNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.type = _data["type"] ? NotificationTypeDto.fromJS(_data["type"]) : undefined as any;
            if (Array.isArray(_data["rolesIdToSendTo"])) {
                this.rolesIdToSendTo = [] as any;
                for (let item of _data["rolesIdToSendTo"])
                    this.rolesIdToSendTo!.push(NotificationRoleDto.fromJS(item));
            }
            if (Array.isArray(_data["usersIdToSendTo"])) {
                this.usersIdToSendTo = [] as any;
                for (let item of _data["usersIdToSendTo"])
                    this.usersIdToSendTo!.push(NotificationUserDto.fromJS(item));
            }
            if (Array.isArray(_data["senders"])) {
                this.senders = [] as any;
                for (let item of _data["senders"])
                    this.senders!.push(NotificationSenderDto.fromJS(item));
            }
            this.messageTemplate = _data["messageTemplate"];
            this.titleTemplate = _data["titleTemplate"];
        }
    }

    static fromJS(data: any): DetailNotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new DetailNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["type"] = this.type ? this.type.toJSON() : undefined as any;
        if (Array.isArray(this.rolesIdToSendTo)) {
            data["rolesIdToSendTo"] = [];
            for (let item of this.rolesIdToSendTo)
                data["rolesIdToSendTo"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.usersIdToSendTo)) {
            data["usersIdToSendTo"] = [];
            for (let item of this.usersIdToSendTo)
                data["usersIdToSendTo"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.senders)) {
            data["senders"] = [];
            for (let item of this.senders)
                data["senders"].push(item ? item.toJSON() : undefined as any);
        }
        data["messageTemplate"] = this.messageTemplate;
        data["titleTemplate"] = this.titleTemplate;
        return data;
    }
}

export interface IDetailNotificationDto {
    id?: number;
    description?: string | undefined;
    type?: NotificationTypeDto;
    rolesIdToSendTo?: NotificationRoleDto[] | undefined;
    usersIdToSendTo?: NotificationUserDto[] | undefined;
    senders?: NotificationSenderDto[] | undefined;
    messageTemplate?: string | undefined;
    titleTemplate?: string | undefined;
}

export enum EDPEModeTransport {
    Indefini = "Indefini",
    Terre = "Terre",
    Poste = "Poste",
    Train = "Train",
    Mer = "Mer",
    Air = "Air",
}

export enum EDPEStatut {
    ATraiter = "ATraiter",
    NonValidee = "NonValidee",
    PreparationMagasinierEnCours = "PreparationMagasinierEnCours",
    PreparationMagasinierAReprendre = "PreparationMagasinierAReprendre",
    DispoEmballage = "DispoEmballage",
    ProblemeQualite = "ProblemeQualite",
    EmballageEnCours = "EmballageEnCours",
    EmballageAReprendre = "EmballageAReprendre",
    Interruption = "Interruption",
    AttenteValidationSAP = "AttenteValidationSAP",
    Annulee = "Annulee",
    DispoChargement = "DispoChargement",
    EnCoursChargement = "EnCoursChargement",
    Expediee = "Expediee",
    SupprimeeParSap = "SupprimeeParSap",
    StatutIndefini = "StatutIndefini",
}

export enum EDPETypePriorite {
    Aucune = "Aucune",
    ClientTousLesJours = "ClientTousLesJours",
    ClientParJour = "ClientParJour",
    Manuelle = "Manuelle",
}

export enum ESAMIncomingMessageStatus {
    Untreated = "Untreated",
    Failed = "Failed",
    Rejected = "Rejected",
    Integrated = "Integrated",
    ToBeRetried = "ToBeRetried",
}

export enum ESAMIncomingMessageValidationStatut {
    Unknown = "Unknown",
    Valid = "Valid",
    NotValid = "NotValid",
}

export enum ESAMOutgoingMessageStatus {
    Untreated = "Untreated",
    Failed = "Failed",
    Rejected = "Rejected",
    ToBeRetried = "ToBeRetried",
    Timeout = "Timeout",
    TakenInAccount = "TakenInAccount",
    Transmitted = "Transmitted",
}

export enum EScheduledTaskEventType {
    Start = "Start",
    Completed = "Completed",
    Error = "Error",
    Cancel = "Cancel",
}

export enum EScheduledTaskExecutionStatus {
    Idle = "Idle",
    Running = "Running",
    Aborting = "Aborting",
}

export enum ESettingType {
    String = "String",
    Bool = "Bool",
    Int = "Int",
    Float = "Float",
    Date = "Date",
}

export enum EStatutDemandeApproTag {
    EnCours = "EnCours",
    Ok = "Ok",
}

export enum ETypeArticle {
    Standard = "Standard",
    Ouvert = "Ouvert",
    HorsStandard = "HorsStandard",
}

export enum ETypeDemandeTransport {
    AnomaliesVersStock = "AnomaliesVersStock",
    StockVersAnomalies = "StockVersAnomalies",
}

export enum ETypeGerbable {
    NonGerbable = "NonGerbable",
    GerbablePar2 = "GerbablePar2",
    GerbablePar3 = "GerbablePar3",
    GerbablePar4 = "GerbablePar4",
    GerbablePar5 = "GerbablePar5",
}

export enum ETypeRecherche {
    Piece = "Piece",
    OF = "OF",
    Tag = "Tag",
    Zone = "Zone",
}

export class EditPriorisationParametrageDto implements IEditPriorisationParametrageDto {
    id?: number;
    client?: string | undefined;
    isPrioritaireLundi?: boolean;
    isPrioritaireMardi?: boolean;
    isPrioritaireMercredi?: boolean;
    isPrioritaireJeudi?: boolean;
    isPrioritaireVendredi?: boolean;

    constructor(data?: IEditPriorisationParametrageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.client = _data["client"];
            this.isPrioritaireLundi = _data["isPrioritaireLundi"];
            this.isPrioritaireMardi = _data["isPrioritaireMardi"];
            this.isPrioritaireMercredi = _data["isPrioritaireMercredi"];
            this.isPrioritaireJeudi = _data["isPrioritaireJeudi"];
            this.isPrioritaireVendredi = _data["isPrioritaireVendredi"];
        }
    }

    static fromJS(data: any): EditPriorisationParametrageDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditPriorisationParametrageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["client"] = this.client;
        data["isPrioritaireLundi"] = this.isPrioritaireLundi;
        data["isPrioritaireMardi"] = this.isPrioritaireMardi;
        data["isPrioritaireMercredi"] = this.isPrioritaireMercredi;
        data["isPrioritaireJeudi"] = this.isPrioritaireJeudi;
        data["isPrioritaireVendredi"] = this.isPrioritaireVendredi;
        return data;
    }
}

export interface IEditPriorisationParametrageDto {
    id?: number;
    client?: string | undefined;
    isPrioritaireLundi?: boolean;
    isPrioritaireMardi?: boolean;
    isPrioritaireMercredi?: boolean;
    isPrioritaireJeudi?: boolean;
    isPrioritaireVendredi?: boolean;
}

export class ElementDto implements IElementDto {
    article?: string | undefined;
    nbPieces?: string | undefined;
    numeroSerie?: string | undefined;
    numeroPDL?: string | undefined;

    constructor(data?: IElementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.article = _data["article"];
            this.nbPieces = _data["nbPieces"];
            this.numeroSerie = _data["numeroSerie"];
            this.numeroPDL = _data["numeroPDL"];
        }
    }

    static fromJS(data: any): ElementDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["article"] = this.article;
        data["nbPieces"] = this.nbPieces;
        data["numeroSerie"] = this.numeroSerie;
        data["numeroPDL"] = this.numeroPDL;
        return data;
    }
}

export interface IElementDto {
    article?: string | undefined;
    nbPieces?: string | undefined;
    numeroSerie?: string | undefined;
    numeroPDL?: string | undefined;
}

export class EtiquetteDto implements IEtiquetteDto {
    client?: string | undefined;
    elements?: ElementDto[] | undefined;

    constructor(data?: IEtiquetteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.client = _data["client"];
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(ElementDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EtiquetteDto {
        data = typeof data === 'object' ? data : {};
        let result = new EtiquetteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["client"] = this.client;
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEtiquetteDto {
    client?: string | undefined;
    elements?: ElementDto[] | undefined;
}

export class GroupePiecesDto implements IGroupePiecesDto {
    id?: number;
    zones?: SearchZoneDto[] | undefined;
    codeZones?: string | undefined;
    pieces?: SearchPieceDto[] | undefined;
    piecesNonRecherchees?: SearchPieceDto[] | undefined;
    notFounds?: string[] | undefined;
    localisation?: string | undefined;
    tagIdentifier?: string | undefined;
    idTag?: number | undefined;
    dateUtc?: dayjs.Dayjs;

    constructor(data?: IGroupePiecesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["zones"])) {
                this.zones = [] as any;
                for (let item of _data["zones"])
                    this.zones!.push(SearchZoneDto.fromJS(item));
            }
            this.codeZones = _data["codeZones"];
            if (Array.isArray(_data["pieces"])) {
                this.pieces = [] as any;
                for (let item of _data["pieces"])
                    this.pieces!.push(SearchPieceDto.fromJS(item));
            }
            if (Array.isArray(_data["piecesNonRecherchees"])) {
                this.piecesNonRecherchees = [] as any;
                for (let item of _data["piecesNonRecherchees"])
                    this.piecesNonRecherchees!.push(SearchPieceDto.fromJS(item));
            }
            if (Array.isArray(_data["notFounds"])) {
                this.notFounds = [] as any;
                for (let item of _data["notFounds"])
                    this.notFounds!.push(item);
            }
            this.localisation = _data["localisation"];
            this.tagIdentifier = _data["tagIdentifier"];
            this.idTag = _data["idTag"];
            this.dateUtc = _data["dateUtc"] ? dayjs(_data["dateUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): GroupePiecesDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupePiecesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.zones)) {
            data["zones"] = [];
            for (let item of this.zones)
                data["zones"].push(item ? item.toJSON() : undefined as any);
        }
        data["codeZones"] = this.codeZones;
        if (Array.isArray(this.pieces)) {
            data["pieces"] = [];
            for (let item of this.pieces)
                data["pieces"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.piecesNonRecherchees)) {
            data["piecesNonRecherchees"] = [];
            for (let item of this.piecesNonRecherchees)
                data["piecesNonRecherchees"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.notFounds)) {
            data["notFounds"] = [];
            for (let item of this.notFounds)
                data["notFounds"].push(item);
        }
        data["localisation"] = this.localisation;
        data["tagIdentifier"] = this.tagIdentifier;
        data["idTag"] = this.idTag;
        data["dateUtc"] = this.dateUtc ? this.dateUtc.toISOString() : undefined as any;
        return data;
    }
}

export interface IGroupePiecesDto {
    id?: number;
    zones?: SearchZoneDto[] | undefined;
    codeZones?: string | undefined;
    pieces?: SearchPieceDto[] | undefined;
    piecesNonRecherchees?: SearchPieceDto[] | undefined;
    notFounds?: string[] | undefined;
    localisation?: string | undefined;
    tagIdentifier?: string | undefined;
    idTag?: number | undefined;
    dateUtc?: dayjs.Dayjs;
}

export class HistoriqueAppairageDto implements IHistoriqueAppairageDto {
    id?: number;
    dateAppairage?: dayjs.Dayjs;
    pieceId?: number;
    tagId?: number;

    constructor(data?: IHistoriqueAppairageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateAppairage = _data["dateAppairage"] ? dayjs(_data["dateAppairage"].toString()) : undefined as any;
            this.pieceId = _data["pieceId"];
            this.tagId = _data["tagId"];
        }
    }

    static fromJS(data: any): HistoriqueAppairageDto {
        data = typeof data === 'object' ? data : {};
        let result = new HistoriqueAppairageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateAppairage"] = this.dateAppairage ? this.dateAppairage.toISOString() : undefined as any;
        data["pieceId"] = this.pieceId;
        data["tagId"] = this.tagId;
        return data;
    }
}

export interface IHistoriqueAppairageDto {
    id?: number;
    dateAppairage?: dayjs.Dayjs;
    pieceId?: number;
    tagId?: number;
}

export class IncomingMessageDto implements IIncomingMessageDto {
    id?: number;
    messageType?: string | undefined;
    messageFullType?: string | undefined;
    creationTime?: dayjs.Dayjs;
    lastError?: string | undefined;
    status?: ESAMIncomingMessageStatus;
    validationStatus?: ESAMIncomingMessageValidationStatut;
    tenantId?: number | undefined;
    lastTryDate?: dayjs.Dayjs | undefined;
    tryCount?: number;
    keyWords?: string | undefined;

    constructor(data?: IIncomingMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.messageType = _data["messageType"];
            this.messageFullType = _data["messageFullType"];
            this.creationTime = _data["creationTime"] ? dayjs(_data["creationTime"].toString()) : undefined as any;
            this.lastError = _data["lastError"];
            this.status = _data["status"];
            this.validationStatus = _data["validationStatus"];
            this.tenantId = _data["tenantId"];
            this.lastTryDate = _data["lastTryDate"] ? dayjs(_data["lastTryDate"].toString()) : undefined as any;
            this.tryCount = _data["tryCount"];
            this.keyWords = _data["keyWords"];
        }
    }

    static fromJS(data: any): IncomingMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["messageType"] = this.messageType;
        data["messageFullType"] = this.messageFullType;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["lastError"] = this.lastError;
        data["status"] = this.status;
        data["validationStatus"] = this.validationStatus;
        data["tenantId"] = this.tenantId;
        data["lastTryDate"] = this.lastTryDate ? this.lastTryDate.toISOString() : undefined as any;
        data["tryCount"] = this.tryCount;
        data["keyWords"] = this.keyWords;
        return data;
    }
}

export interface IIncomingMessageDto {
    id?: number;
    messageType?: string | undefined;
    messageFullType?: string | undefined;
    creationTime?: dayjs.Dayjs;
    lastError?: string | undefined;
    status?: ESAMIncomingMessageStatus;
    validationStatus?: ESAMIncomingMessageValidationStatut;
    tenantId?: number | undefined;
    lastTryDate?: dayjs.Dayjs | undefined;
    tryCount?: number;
    keyWords?: string | undefined;
}

export class IncomingMessageFullDto implements IIncomingMessageFullDto {
    id?: number;
    messageType?: string | undefined;
    messageFullType?: string | undefined;
    creationTime?: dayjs.Dayjs;
    initialContent?: string | undefined;
    content?: string | undefined;
    lastError?: string | undefined;
    status?: ESAMIncomingMessageStatus;
    validationStatus?: ESAMIncomingMessageValidationStatut;
    tenantId?: number | undefined;
    lastTryDate?: dayjs.Dayjs | undefined;
    tryCount?: number;
    keyWords?: string | undefined;
    indentedInitialContent?: string | undefined;
    indentedContent?: string | undefined;

    constructor(data?: IIncomingMessageFullDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.messageType = _data["messageType"];
            this.messageFullType = _data["messageFullType"];
            this.creationTime = _data["creationTime"] ? dayjs(_data["creationTime"].toString()) : undefined as any;
            this.initialContent = _data["initialContent"];
            this.content = _data["content"];
            this.lastError = _data["lastError"];
            this.status = _data["status"];
            this.validationStatus = _data["validationStatus"];
            this.tenantId = _data["tenantId"];
            this.lastTryDate = _data["lastTryDate"] ? dayjs(_data["lastTryDate"].toString()) : undefined as any;
            this.tryCount = _data["tryCount"];
            this.keyWords = _data["keyWords"];
            this.indentedInitialContent = _data["indentedInitialContent"];
            this.indentedContent = _data["indentedContent"];
        }
    }

    static fromJS(data: any): IncomingMessageFullDto {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingMessageFullDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["messageType"] = this.messageType;
        data["messageFullType"] = this.messageFullType;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["initialContent"] = this.initialContent;
        data["content"] = this.content;
        data["lastError"] = this.lastError;
        data["status"] = this.status;
        data["validationStatus"] = this.validationStatus;
        data["tenantId"] = this.tenantId;
        data["lastTryDate"] = this.lastTryDate ? this.lastTryDate.toISOString() : undefined as any;
        data["tryCount"] = this.tryCount;
        data["keyWords"] = this.keyWords;
        data["indentedInitialContent"] = this.indentedInitialContent;
        data["indentedContent"] = this.indentedContent;
        return data;
    }
}

export interface IIncomingMessageFullDto {
    id?: number;
    messageType?: string | undefined;
    messageFullType?: string | undefined;
    creationTime?: dayjs.Dayjs;
    initialContent?: string | undefined;
    content?: string | undefined;
    lastError?: string | undefined;
    status?: ESAMIncomingMessageStatus;
    validationStatus?: ESAMIncomingMessageValidationStatut;
    tenantId?: number | undefined;
    lastTryDate?: dayjs.Dayjs | undefined;
    tryCount?: number;
    keyWords?: string | undefined;
    indentedInitialContent?: string | undefined;
    indentedContent?: string | undefined;
}

export class InterruptionDto implements IInterruptionDto {
    id?: number;
    code?: string | undefined;
    isSysteme?: boolean;
    isCommentaireObligatoire?: boolean;

    constructor(data?: IInterruptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.isSysteme = _data["isSysteme"];
            this.isCommentaireObligatoire = _data["isCommentaireObligatoire"];
        }
    }

    static fromJS(data: any): InterruptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new InterruptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["isSysteme"] = this.isSysteme;
        data["isCommentaireObligatoire"] = this.isCommentaireObligatoire;
        return data;
    }
}

export interface IInterruptionDto {
    id?: number;
    code?: string | undefined;
    isSysteme?: boolean;
    isCommentaireObligatoire?: boolean;
}

export class LightDemandeTransportDto implements ILightDemandeTransportDto {
    id?: number;
    type?: ETypeDemandeTransport;
    piece?: LightPieceDto;
    pieceId?: number;
    createdDate?: dayjs.Dayjs | undefined;

    constructor(data?: ILightDemandeTransportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.piece = _data["piece"] ? LightPieceDto.fromJS(_data["piece"]) : undefined as any;
            this.pieceId = _data["pieceId"];
            this.createdDate = _data["createdDate"] ? dayjs(_data["createdDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): LightDemandeTransportDto {
        data = typeof data === 'object' ? data : {};
        let result = new LightDemandeTransportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["piece"] = this.piece ? this.piece.toJSON() : undefined as any;
        data["pieceId"] = this.pieceId;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        return data;
    }
}

export interface ILightDemandeTransportDto {
    id?: number;
    type?: ETypeDemandeTransport;
    piece?: LightPieceDto;
    pieceId?: number;
    createdDate?: dayjs.Dayjs | undefined;
}

export class LightOrdreFabricationDto implements ILightOrdreFabricationDto {
    id?: number;
    numeroOf?: string | undefined;

    constructor(data?: ILightOrdreFabricationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.numeroOf = _data["numeroOf"];
        }
    }

    static fromJS(data: any): LightOrdreFabricationDto {
        data = typeof data === 'object' ? data : {};
        let result = new LightOrdreFabricationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["numeroOf"] = this.numeroOf;
        return data;
    }
}

export interface ILightOrdreFabricationDto {
    id?: number;
    numeroOf?: string | undefined;
}

export class LightPieceDto implements ILightPieceDto {
    id?: number;
    numeroSerie?: string | undefined;
    posteCharge?: string | undefined;
    ordreFabrication?: LightOrdreFabricationDto;
    ordreFabricationId?: number | undefined;

    constructor(data?: ILightPieceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.numeroSerie = _data["numeroSerie"];
            this.posteCharge = _data["posteCharge"];
            this.ordreFabrication = _data["ordreFabrication"] ? LightOrdreFabricationDto.fromJS(_data["ordreFabrication"]) : undefined as any;
            this.ordreFabricationId = _data["ordreFabricationId"];
        }
    }

    static fromJS(data: any): LightPieceDto {
        data = typeof data === 'object' ? data : {};
        let result = new LightPieceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["numeroSerie"] = this.numeroSerie;
        data["posteCharge"] = this.posteCharge;
        data["ordreFabrication"] = this.ordreFabrication ? this.ordreFabrication.toJSON() : undefined as any;
        data["ordreFabricationId"] = this.ordreFabricationId;
        return data;
    }
}

export interface ILightPieceDto {
    id?: number;
    numeroSerie?: string | undefined;
    posteCharge?: string | undefined;
    ordreFabrication?: LightOrdreFabricationDto;
    ordreFabricationId?: number | undefined;
}

export class MovePairingPieceDto implements IMovePairingPieceDto {
    id?: number;
    numeroSerie?: string | undefined;
    tag?: MovePairingTagDto;

    constructor(data?: IMovePairingPieceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.numeroSerie = _data["numeroSerie"];
            this.tag = _data["tag"] ? MovePairingTagDto.fromJS(_data["tag"]) : undefined as any;
        }
    }

    static fromJS(data: any): MovePairingPieceDto {
        data = typeof data === 'object' ? data : {};
        let result = new MovePairingPieceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["numeroSerie"] = this.numeroSerie;
        data["tag"] = this.tag ? this.tag.toJSON() : undefined as any;
        return data;
    }
}

export interface IMovePairingPieceDto {
    id?: number;
    numeroSerie?: string | undefined;
    tag?: MovePairingTagDto;
}

export class MovePairingTagDto implements IMovePairingTagDto {
    id?: number;
    tagIdentifier?: string | undefined;
    nom?: string | undefined;

    constructor(data?: IMovePairingTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tagIdentifier = _data["tagIdentifier"];
            this.nom = _data["nom"];
        }
    }

    static fromJS(data: any): MovePairingTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new MovePairingTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tagIdentifier"] = this.tagIdentifier;
        data["nom"] = this.nom;
        return data;
    }
}

export interface IMovePairingTagDto {
    id?: number;
    tagIdentifier?: string | undefined;
    nom?: string | undefined;
}

export class NewPriorisationParametrageDto implements INewPriorisationParametrageDto {
    client?: string | undefined;
    isPrioritaireLundi?: boolean;
    isPrioritaireMardi?: boolean;
    isPrioritaireMercredi?: boolean;
    isPrioritaireJeudi?: boolean;
    isPrioritaireVendredi?: boolean;

    constructor(data?: INewPriorisationParametrageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.client = _data["client"];
            this.isPrioritaireLundi = _data["isPrioritaireLundi"];
            this.isPrioritaireMardi = _data["isPrioritaireMardi"];
            this.isPrioritaireMercredi = _data["isPrioritaireMercredi"];
            this.isPrioritaireJeudi = _data["isPrioritaireJeudi"];
            this.isPrioritaireVendredi = _data["isPrioritaireVendredi"];
        }
    }

    static fromJS(data: any): NewPriorisationParametrageDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewPriorisationParametrageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["client"] = this.client;
        data["isPrioritaireLundi"] = this.isPrioritaireLundi;
        data["isPrioritaireMardi"] = this.isPrioritaireMardi;
        data["isPrioritaireMercredi"] = this.isPrioritaireMercredi;
        data["isPrioritaireJeudi"] = this.isPrioritaireJeudi;
        data["isPrioritaireVendredi"] = this.isPrioritaireVendredi;
        return data;
    }
}

export interface INewPriorisationParametrageDto {
    client?: string | undefined;
    isPrioritaireLundi?: boolean;
    isPrioritaireMardi?: boolean;
    isPrioritaireMercredi?: boolean;
    isPrioritaireJeudi?: boolean;
    isPrioritaireVendredi?: boolean;
}

export class NotificationDto implements INotificationDto {
    id?: number;
    description?: string | undefined;
    notificationType?: string | undefined;
    notificationFullType?: string | undefined;
    messageTemplate?: string | undefined;
    titleTemplate?: string | undefined;
    createdBy?: number | undefined;
    modifiedBy?: number | undefined;
    createdDate?: dayjs.Dayjs | undefined;
    modifiedDate?: dayjs.Dayjs | undefined;
    senders?: NotificationSenderDto[] | undefined;
    sendersText?: string | undefined;

    constructor(data?: INotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.notificationType = _data["notificationType"];
            this.notificationFullType = _data["notificationFullType"];
            this.messageTemplate = _data["messageTemplate"];
            this.titleTemplate = _data["titleTemplate"];
            this.createdBy = _data["createdBy"];
            this.modifiedBy = _data["modifiedBy"];
            this.createdDate = _data["createdDate"] ? dayjs(_data["createdDate"].toString()) : undefined as any;
            this.modifiedDate = _data["modifiedDate"] ? dayjs(_data["modifiedDate"].toString()) : undefined as any;
            if (Array.isArray(_data["senders"])) {
                this.senders = [] as any;
                for (let item of _data["senders"])
                    this.senders!.push(NotificationSenderDto.fromJS(item));
            }
            this.sendersText = _data["sendersText"];
        }
    }

    static fromJS(data: any): NotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["notificationType"] = this.notificationType;
        data["notificationFullType"] = this.notificationFullType;
        data["messageTemplate"] = this.messageTemplate;
        data["titleTemplate"] = this.titleTemplate;
        data["createdBy"] = this.createdBy;
        data["modifiedBy"] = this.modifiedBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : undefined as any;
        if (Array.isArray(this.senders)) {
            data["senders"] = [];
            for (let item of this.senders)
                data["senders"].push(item ? item.toJSON() : undefined as any);
        }
        data["sendersText"] = this.sendersText;
        return data;
    }
}

export interface INotificationDto {
    id?: number;
    description?: string | undefined;
    notificationType?: string | undefined;
    notificationFullType?: string | undefined;
    messageTemplate?: string | undefined;
    titleTemplate?: string | undefined;
    createdBy?: number | undefined;
    modifiedBy?: number | undefined;
    createdDate?: dayjs.Dayjs | undefined;
    modifiedDate?: dayjs.Dayjs | undefined;
    senders?: NotificationSenderDto[] | undefined;
    sendersText?: string | undefined;
}

export class NotificationMessageDto implements INotificationMessageDto {
    id?: number;
    messageText?: string | undefined;
    messageTitle?: string | undefined;
    status?: NotificationMessageStatut;
    lastError?: string | undefined;
    notificationNotificationType?: string | undefined;
    recipientId?: number | undefined;
    senderType?: string | undefined;
    senderFullType?: string | undefined;
    sendDate?: dayjs.Dayjs | undefined;
    createdDate?: dayjs.Dayjs;
    furtherInformation?: string | undefined;
    destinataire?: string | undefined;

    constructor(data?: INotificationMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.messageText = _data["messageText"];
            this.messageTitle = _data["messageTitle"];
            this.status = _data["status"];
            this.lastError = _data["lastError"];
            this.notificationNotificationType = _data["notificationNotificationType"];
            this.recipientId = _data["recipientId"];
            this.senderType = _data["senderType"];
            this.senderFullType = _data["senderFullType"];
            this.sendDate = _data["sendDate"] ? dayjs(_data["sendDate"].toString()) : undefined as any;
            this.createdDate = _data["createdDate"] ? dayjs(_data["createdDate"].toString()) : undefined as any;
            this.furtherInformation = _data["furtherInformation"];
            this.destinataire = _data["destinataire"];
        }
    }

    static fromJS(data: any): NotificationMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["messageText"] = this.messageText;
        data["messageTitle"] = this.messageTitle;
        data["status"] = this.status;
        data["lastError"] = this.lastError;
        data["notificationNotificationType"] = this.notificationNotificationType;
        data["recipientId"] = this.recipientId;
        data["senderType"] = this.senderType;
        data["senderFullType"] = this.senderFullType;
        data["sendDate"] = this.sendDate ? this.sendDate.toISOString() : undefined as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["furtherInformation"] = this.furtherInformation;
        data["destinataire"] = this.destinataire;
        return data;
    }
}

export interface INotificationMessageDto {
    id?: number;
    messageText?: string | undefined;
    messageTitle?: string | undefined;
    status?: NotificationMessageStatut;
    lastError?: string | undefined;
    notificationNotificationType?: string | undefined;
    recipientId?: number | undefined;
    senderType?: string | undefined;
    senderFullType?: string | undefined;
    sendDate?: dayjs.Dayjs | undefined;
    createdDate?: dayjs.Dayjs;
    furtherInformation?: string | undefined;
    destinataire?: string | undefined;
}

export enum NotificationMessageStatut {
    New = "New",
    Sent = "Sent",
    Error = "Error",
    Read = "Read",
    NewManual = "NewManual",
}

export class NotificationRoleDto implements INotificationRoleDto {
    id?: number;
    roleId?: number;

    constructor(data?: INotificationRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): NotificationRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["roleId"] = this.roleId;
        return data;
    }
}

export interface INotificationRoleDto {
    id?: number;
    roleId?: number;
}

export class NotificationSenderDto implements INotificationSenderDto {
    id?: number;
    senderType?: string | undefined;
    senderFullType?: string | undefined;
    selected?: boolean;

    constructor(data?: INotificationSenderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.senderType = _data["senderType"];
            this.senderFullType = _data["senderFullType"];
            this.selected = _data["selected"];
        }
    }

    static fromJS(data: any): NotificationSenderDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationSenderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["senderType"] = this.senderType;
        data["senderFullType"] = this.senderFullType;
        data["selected"] = this.selected;
        return data;
    }
}

export interface INotificationSenderDto {
    id?: number;
    senderType?: string | undefined;
    senderFullType?: string | undefined;
    selected?: boolean;
}

export class NotificationTypeDto implements INotificationTypeDto {
    fullName?: string | undefined;
    name?: string | undefined;
    titleDescription?: string | undefined;
    messageDescription?: string | undefined;
    description?: string | undefined;

    constructor(data?: INotificationTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.name = _data["name"];
            this.titleDescription = _data["titleDescription"];
            this.messageDescription = _data["messageDescription"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): NotificationTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["name"] = this.name;
        data["titleDescription"] = this.titleDescription;
        data["messageDescription"] = this.messageDescription;
        data["description"] = this.description;
        return data;
    }
}

export interface INotificationTypeDto {
    fullName?: string | undefined;
    name?: string | undefined;
    titleDescription?: string | undefined;
    messageDescription?: string | undefined;
    description?: string | undefined;
}

export class NotificationUserDto implements INotificationUserDto {
    id?: number;
    userId?: number;

    constructor(data?: INotificationUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): NotificationUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        return data;
    }
}

export interface INotificationUserDto {
    id?: number;
    userId?: number;
}

export class OutgoingMessageDto implements IOutgoingMessageDto {
    id?: number;
    messageType?: string | undefined;
    messageFullType?: string | undefined;
    lastError?: string | undefined;
    status?: ESAMOutgoingMessageStatus;
    creationTime?: dayjs.Dayjs;
    tenantId?: number | undefined;
    lastTryDate?: dayjs.Dayjs | undefined;
    acknowledgementId?: string | undefined;
    tryCount?: number;

    constructor(data?: IOutgoingMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.messageType = _data["messageType"];
            this.messageFullType = _data["messageFullType"];
            this.lastError = _data["lastError"];
            this.status = _data["status"];
            this.creationTime = _data["creationTime"] ? dayjs(_data["creationTime"].toString()) : undefined as any;
            this.tenantId = _data["tenantId"];
            this.lastTryDate = _data["lastTryDate"] ? dayjs(_data["lastTryDate"].toString()) : undefined as any;
            this.acknowledgementId = _data["acknowledgementId"];
            this.tryCount = _data["tryCount"];
        }
    }

    static fromJS(data: any): OutgoingMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutgoingMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["messageType"] = this.messageType;
        data["messageFullType"] = this.messageFullType;
        data["lastError"] = this.lastError;
        data["status"] = this.status;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["tenantId"] = this.tenantId;
        data["lastTryDate"] = this.lastTryDate ? this.lastTryDate.toISOString() : undefined as any;
        data["acknowledgementId"] = this.acknowledgementId;
        data["tryCount"] = this.tryCount;
        return data;
    }
}

export interface IOutgoingMessageDto {
    id?: number;
    messageType?: string | undefined;
    messageFullType?: string | undefined;
    lastError?: string | undefined;
    status?: ESAMOutgoingMessageStatus;
    creationTime?: dayjs.Dayjs;
    tenantId?: number | undefined;
    lastTryDate?: dayjs.Dayjs | undefined;
    acknowledgementId?: string | undefined;
    tryCount?: number;
}

export class OutgoingMessageFullDto implements IOutgoingMessageFullDto {
    id?: number;
    messageType?: string | undefined;
    messageFullType?: string | undefined;
    initialContent?: string | undefined;
    content?: string | undefined;
    lastError?: string | undefined;
    status?: ESAMOutgoingMessageStatus;
    creationTime?: dayjs.Dayjs;
    tenantId?: number | undefined;
    lastTryDate?: dayjs.Dayjs | undefined;
    acknowledgementId?: string | undefined;
    tryCount?: number;
    indentedContent?: string | undefined;

    constructor(data?: IOutgoingMessageFullDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.messageType = _data["messageType"];
            this.messageFullType = _data["messageFullType"];
            this.initialContent = _data["initialContent"];
            this.content = _data["content"];
            this.lastError = _data["lastError"];
            this.status = _data["status"];
            this.creationTime = _data["creationTime"] ? dayjs(_data["creationTime"].toString()) : undefined as any;
            this.tenantId = _data["tenantId"];
            this.lastTryDate = _data["lastTryDate"] ? dayjs(_data["lastTryDate"].toString()) : undefined as any;
            this.acknowledgementId = _data["acknowledgementId"];
            this.tryCount = _data["tryCount"];
            this.indentedContent = _data["indentedContent"];
        }
    }

    static fromJS(data: any): OutgoingMessageFullDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutgoingMessageFullDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["messageType"] = this.messageType;
        data["messageFullType"] = this.messageFullType;
        data["initialContent"] = this.initialContent;
        data["content"] = this.content;
        data["lastError"] = this.lastError;
        data["status"] = this.status;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["tenantId"] = this.tenantId;
        data["lastTryDate"] = this.lastTryDate ? this.lastTryDate.toISOString() : undefined as any;
        data["acknowledgementId"] = this.acknowledgementId;
        data["tryCount"] = this.tryCount;
        data["indentedContent"] = this.indentedContent;
        return data;
    }
}

export interface IOutgoingMessageFullDto {
    id?: number;
    messageType?: string | undefined;
    messageFullType?: string | undefined;
    initialContent?: string | undefined;
    content?: string | undefined;
    lastError?: string | undefined;
    status?: ESAMOutgoingMessageStatus;
    creationTime?: dayjs.Dayjs;
    tenantId?: number | undefined;
    lastTryDate?: dayjs.Dayjs | undefined;
    acknowledgementId?: string | undefined;
    tryCount?: number;
    indentedContent?: string | undefined;
}

export class PairingColisDto implements IPairingColisDto {
    id?: number;
    nom?: string | undefined;
    type?: ETypeArticle;
    longueur?: number;
    largeur?: number;
    hauteur?: number;
    poidsTare?: number;
    poidsBrutTheorique?: number;
    poidsBrutReel?: number;
    gerbabilite?: ETypeGerbable;
    codeArticleEmballage?: string | undefined;
    typeArticleEmballage?: ETypeArticle;
    pieces?: PairingPieceDto[] | undefined;
    tagIdentifier?: string | undefined;
    tagId?: number | undefined;
    isValider?: boolean;
    autresDpes?: PairingDemandeExpeditionDto[] | undefined;

    constructor(data?: IPairingColisDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nom = _data["nom"];
            this.type = _data["type"];
            this.longueur = _data["longueur"];
            this.largeur = _data["largeur"];
            this.hauteur = _data["hauteur"];
            this.poidsTare = _data["poidsTare"];
            this.poidsBrutTheorique = _data["poidsBrutTheorique"];
            this.poidsBrutReel = _data["poidsBrutReel"];
            this.gerbabilite = _data["gerbabilite"];
            this.codeArticleEmballage = _data["codeArticleEmballage"];
            this.typeArticleEmballage = _data["typeArticleEmballage"];
            if (Array.isArray(_data["pieces"])) {
                this.pieces = [] as any;
                for (let item of _data["pieces"])
                    this.pieces!.push(PairingPieceDto.fromJS(item));
            }
            this.tagIdentifier = _data["tagIdentifier"];
            this.tagId = _data["tagId"];
            this.isValider = _data["isValider"];
            if (Array.isArray(_data["autresDpes"])) {
                this.autresDpes = [] as any;
                for (let item of _data["autresDpes"])
                    this.autresDpes!.push(PairingDemandeExpeditionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PairingColisDto {
        data = typeof data === 'object' ? data : {};
        let result = new PairingColisDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nom"] = this.nom;
        data["type"] = this.type;
        data["longueur"] = this.longueur;
        data["largeur"] = this.largeur;
        data["hauteur"] = this.hauteur;
        data["poidsTare"] = this.poidsTare;
        data["poidsBrutTheorique"] = this.poidsBrutTheorique;
        data["poidsBrutReel"] = this.poidsBrutReel;
        data["gerbabilite"] = this.gerbabilite;
        data["codeArticleEmballage"] = this.codeArticleEmballage;
        data["typeArticleEmballage"] = this.typeArticleEmballage;
        if (Array.isArray(this.pieces)) {
            data["pieces"] = [];
            for (let item of this.pieces)
                data["pieces"].push(item ? item.toJSON() : undefined as any);
        }
        data["tagIdentifier"] = this.tagIdentifier;
        data["tagId"] = this.tagId;
        data["isValider"] = this.isValider;
        if (Array.isArray(this.autresDpes)) {
            data["autresDpes"] = [];
            for (let item of this.autresDpes)
                data["autresDpes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPairingColisDto {
    id?: number;
    nom?: string | undefined;
    type?: ETypeArticle;
    longueur?: number;
    largeur?: number;
    hauteur?: number;
    poidsTare?: number;
    poidsBrutTheorique?: number;
    poidsBrutReel?: number;
    gerbabilite?: ETypeGerbable;
    codeArticleEmballage?: string | undefined;
    typeArticleEmballage?: ETypeArticle;
    pieces?: PairingPieceDto[] | undefined;
    tagIdentifier?: string | undefined;
    tagId?: number | undefined;
    isValider?: boolean;
    autresDpes?: PairingDemandeExpeditionDto[] | undefined;
}

export class PairingDemandeExpeditionDto implements IPairingDemandeExpeditionDto {
    id?: number;
    numeroPDL?: string | undefined;
    pieces?: PairingPieceDto[] | undefined;

    constructor(data?: IPairingDemandeExpeditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.numeroPDL = _data["numeroPDL"];
            if (Array.isArray(_data["pieces"])) {
                this.pieces = [] as any;
                for (let item of _data["pieces"])
                    this.pieces!.push(PairingPieceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PairingDemandeExpeditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PairingDemandeExpeditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["numeroPDL"] = this.numeroPDL;
        if (Array.isArray(this.pieces)) {
            data["pieces"] = [];
            for (let item of this.pieces)
                data["pieces"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPairingDemandeExpeditionDto {
    id?: number;
    numeroPDL?: string | undefined;
    pieces?: PairingPieceDto[] | undefined;
}

export class PairingPieceDto implements IPairingPieceDto {
    id?: number;
    numeroSerie?: string | undefined;
    poidsTheorique?: number;
    numeroOf?: string | undefined;
    isAppaire?: boolean;
    inAnotherDPE?: boolean;
    anotherDPENumeroPDL?: string | undefined;
    position?: SearchPositionDto;
    numeroSerieClient?: string | undefined;
    isDeletedFromDPE?: boolean;
    isAddedToDPE?: boolean;
    tagId?: number | undefined;
    isAnomalie?: boolean;

    constructor(data?: IPairingPieceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.numeroSerie = _data["numeroSerie"];
            this.poidsTheorique = _data["poidsTheorique"];
            this.numeroOf = _data["numeroOf"];
            this.isAppaire = _data["isAppaire"];
            this.inAnotherDPE = _data["inAnotherDPE"];
            this.anotherDPENumeroPDL = _data["anotherDPENumeroPDL"];
            this.position = _data["position"] ? SearchPositionDto.fromJS(_data["position"]) : undefined as any;
            this.numeroSerieClient = _data["numeroSerieClient"];
            this.isDeletedFromDPE = _data["isDeletedFromDPE"];
            this.isAddedToDPE = _data["isAddedToDPE"];
            this.tagId = _data["tagId"];
            this.isAnomalie = _data["isAnomalie"];
        }
    }

    static fromJS(data: any): PairingPieceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PairingPieceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["numeroSerie"] = this.numeroSerie;
        data["poidsTheorique"] = this.poidsTheorique;
        data["numeroOf"] = this.numeroOf;
        data["isAppaire"] = this.isAppaire;
        data["inAnotherDPE"] = this.inAnotherDPE;
        data["anotherDPENumeroPDL"] = this.anotherDPENumeroPDL;
        data["position"] = this.position ? this.position.toJSON() : undefined as any;
        data["numeroSerieClient"] = this.numeroSerieClient;
        data["isDeletedFromDPE"] = this.isDeletedFromDPE;
        data["isAddedToDPE"] = this.isAddedToDPE;
        data["tagId"] = this.tagId;
        data["isAnomalie"] = this.isAnomalie;
        return data;
    }
}

export interface IPairingPieceDto {
    id?: number;
    numeroSerie?: string | undefined;
    poidsTheorique?: number;
    numeroOf?: string | undefined;
    isAppaire?: boolean;
    inAnotherDPE?: boolean;
    anotherDPENumeroPDL?: string | undefined;
    position?: SearchPositionDto;
    numeroSerieClient?: string | undefined;
    isDeletedFromDPE?: boolean;
    isAddedToDPE?: boolean;
    tagId?: number | undefined;
    isAnomalie?: boolean;
}

export class PairingTagDto implements IPairingTagDto {
    id?: number;
    tagIdentifier?: string | undefined;
    nom?: string | undefined;
    codeZones?: string | undefined;
    pieces?: PairingPieceDto[] | undefined;

    constructor(data?: IPairingTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tagIdentifier = _data["tagIdentifier"];
            this.nom = _data["nom"];
            this.codeZones = _data["codeZones"];
            if (Array.isArray(_data["pieces"])) {
                this.pieces = [] as any;
                for (let item of _data["pieces"])
                    this.pieces!.push(PairingPieceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PairingTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new PairingTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tagIdentifier"] = this.tagIdentifier;
        data["nom"] = this.nom;
        data["codeZones"] = this.codeZones;
        if (Array.isArray(this.pieces)) {
            data["pieces"] = [];
            for (let item of this.pieces)
                data["pieces"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPairingTagDto {
    id?: number;
    tagIdentifier?: string | undefined;
    nom?: string | undefined;
    codeZones?: string | undefined;
    pieces?: PairingPieceDto[] | undefined;
}

export class PieceDemandeTransportDto implements IPieceDemandeTransportDto {
    id?: number;
    numeroSerie?: string | undefined;
    numeroOf?: string | undefined;
    posteCharge?: string | undefined;
    isDeletedFromDPE?: boolean;
    isAddedToDPE?: boolean;

    constructor(data?: IPieceDemandeTransportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.numeroSerie = _data["numeroSerie"];
            this.numeroOf = _data["numeroOf"];
            this.posteCharge = _data["posteCharge"];
            this.isDeletedFromDPE = _data["isDeletedFromDPE"];
            this.isAddedToDPE = _data["isAddedToDPE"];
        }
    }

    static fromJS(data: any): PieceDemandeTransportDto {
        data = typeof data === 'object' ? data : {};
        let result = new PieceDemandeTransportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["numeroSerie"] = this.numeroSerie;
        data["numeroOf"] = this.numeroOf;
        data["posteCharge"] = this.posteCharge;
        data["isDeletedFromDPE"] = this.isDeletedFromDPE;
        data["isAddedToDPE"] = this.isAddedToDPE;
        return data;
    }
}

export interface IPieceDemandeTransportDto {
    id?: number;
    numeroSerie?: string | undefined;
    numeroOf?: string | undefined;
    posteCharge?: string | undefined;
    isDeletedFromDPE?: boolean;
    isAddedToDPE?: boolean;
}

export class PieceDto implements IPieceDto {
    id?: number;
    numeroSerie?: string | undefined;
    numeroOf?: string | undefined;
    tagId?: number | undefined;
    colisId?: number | undefined;
    positions?: PositionDto[] | undefined;
    isDeletedFromDPE?: boolean;
    isAddedToDPE?: boolean;

    constructor(data?: IPieceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.numeroSerie = _data["numeroSerie"];
            this.numeroOf = _data["numeroOf"];
            this.tagId = _data["tagId"];
            this.colisId = _data["colisId"];
            if (Array.isArray(_data["positions"])) {
                this.positions = [] as any;
                for (let item of _data["positions"])
                    this.positions!.push(PositionDto.fromJS(item));
            }
            this.isDeletedFromDPE = _data["isDeletedFromDPE"];
            this.isAddedToDPE = _data["isAddedToDPE"];
        }
    }

    static fromJS(data: any): PieceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PieceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["numeroSerie"] = this.numeroSerie;
        data["numeroOf"] = this.numeroOf;
        data["tagId"] = this.tagId;
        data["colisId"] = this.colisId;
        if (Array.isArray(this.positions)) {
            data["positions"] = [];
            for (let item of this.positions)
                data["positions"].push(item ? item.toJSON() : undefined as any);
        }
        data["isDeletedFromDPE"] = this.isDeletedFromDPE;
        data["isAddedToDPE"] = this.isAddedToDPE;
        return data;
    }
}

export interface IPieceDto {
    id?: number;
    numeroSerie?: string | undefined;
    numeroOf?: string | undefined;
    tagId?: number | undefined;
    colisId?: number | undefined;
    positions?: PositionDto[] | undefined;
    isDeletedFromDPE?: boolean;
    isAddedToDPE?: boolean;
}

export class PieceEtiquetteDto implements IPieceEtiquetteDto {
    id?: number;
    numeroSerie?: string | undefined;
    numeroSerieClient?: string | undefined;
    numeroOf?: string | undefined;

    constructor(data?: IPieceEtiquetteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.numeroSerie = _data["numeroSerie"];
            this.numeroSerieClient = _data["numeroSerieClient"];
            this.numeroOf = _data["numeroOf"];
        }
    }

    static fromJS(data: any): PieceEtiquetteDto {
        data = typeof data === 'object' ? data : {};
        let result = new PieceEtiquetteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["numeroSerie"] = this.numeroSerie;
        data["numeroSerieClient"] = this.numeroSerieClient;
        data["numeroOf"] = this.numeroOf;
        return data;
    }
}

export interface IPieceEtiquetteDto {
    id?: number;
    numeroSerie?: string | undefined;
    numeroSerieClient?: string | undefined;
    numeroOf?: string | undefined;
}

export class PositionDto implements IPositionDto {
    id?: number;
    localisation?: string | undefined;
    precision?: number;
    dateUtc?: dayjs.Dayjs;
    pieceId?: number | undefined;
    colisId?: number | undefined;

    constructor(data?: IPositionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.localisation = _data["localisation"];
            this.precision = _data["precision"];
            this.dateUtc = _data["dateUtc"] ? dayjs(_data["dateUtc"].toString()) : undefined as any;
            this.pieceId = _data["pieceId"];
            this.colisId = _data["colisId"];
        }
    }

    static fromJS(data: any): PositionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PositionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["localisation"] = this.localisation;
        data["precision"] = this.precision;
        data["dateUtc"] = this.dateUtc ? this.dateUtc.toISOString() : undefined as any;
        data["pieceId"] = this.pieceId;
        data["colisId"] = this.colisId;
        return data;
    }
}

export interface IPositionDto {
    id?: number;
    localisation?: string | undefined;
    precision?: number;
    dateUtc?: dayjs.Dayjs;
    pieceId?: number | undefined;
    colisId?: number | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class SAMRoleDto implements ISAMRoleDto {
    id?: number;
    name?: string | undefined;
    selected?: boolean;
    claims?: string[] | undefined;

    constructor(data?: ISAMRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.selected = _data["selected"];
            if (Array.isArray(_data["claims"])) {
                this.claims = [] as any;
                for (let item of _data["claims"])
                    this.claims!.push(item);
            }
        }
    }

    static fromJS(data: any): SAMRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new SAMRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["selected"] = this.selected;
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item);
        }
        return data;
    }
}

export interface ISAMRoleDto {
    id?: number;
    name?: string | undefined;
    selected?: boolean;
    claims?: string[] | undefined;
}

export class SAMUserDto implements ISAMUserDto {
    id?: number;
    locale?: string | undefined;
    userName?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
    selected?: boolean;
    roles?: string[] | undefined;
    isDisabled?: boolean;

    constructor(data?: ISAMUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locale = _data["locale"];
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.password = _data["password"];
            this.selected = _data["selected"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.isDisabled = _data["isDisabled"];
        }
    }

    static fromJS(data: any): SAMUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new SAMUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locale"] = this.locale;
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["password"] = this.password;
        data["selected"] = this.selected;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["isDisabled"] = this.isDisabled;
        return data;
    }
}

export interface ISAMUserDto {
    id?: number;
    locale?: string | undefined;
    userName?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
    selected?: boolean;
    roles?: string[] | undefined;
    isDisabled?: boolean;
}

export class ScheduledTaskDto implements IScheduledTaskDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    samTask?: string | undefined;
    nextTryTime?: dayjs.Dayjs | undefined;
    lastTryTime?: dayjs.Dayjs | undefined;
    isActive?: boolean;
    cronString?: string | undefined;
    executionStatus?: EScheduledTaskExecutionStatus;
    lastExecution?: EScheduledTaskEventType;

    constructor(data?: IScheduledTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.samTask = _data["samTask"];
            this.nextTryTime = _data["nextTryTime"] ? dayjs(_data["nextTryTime"].toString()) : undefined as any;
            this.lastTryTime = _data["lastTryTime"] ? dayjs(_data["lastTryTime"].toString()) : undefined as any;
            this.isActive = _data["isActive"];
            this.cronString = _data["cronString"];
            this.executionStatus = _data["executionStatus"];
            this.lastExecution = _data["lastExecution"];
        }
    }

    static fromJS(data: any): ScheduledTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduledTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["samTask"] = this.samTask;
        data["nextTryTime"] = this.nextTryTime ? this.nextTryTime.toISOString() : undefined as any;
        data["lastTryTime"] = this.lastTryTime ? this.lastTryTime.toISOString() : undefined as any;
        data["isActive"] = this.isActive;
        data["cronString"] = this.cronString;
        data["executionStatus"] = this.executionStatus;
        data["lastExecution"] = this.lastExecution;
        return data;
    }
}

export interface IScheduledTaskDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    samTask?: string | undefined;
    nextTryTime?: dayjs.Dayjs | undefined;
    lastTryTime?: dayjs.Dayjs | undefined;
    isActive?: boolean;
    cronString?: string | undefined;
    executionStatus?: EScheduledTaskExecutionStatus;
    lastExecution?: EScheduledTaskEventType;
}

export class SearchColisEtiquetteDto implements ISearchColisEtiquetteDto {
    id?: number;
    nom?: string | undefined;
    dpEs?: DemandeExpeditionEtiquetteDto[] | undefined;

    constructor(data?: ISearchColisEtiquetteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nom = _data["nom"];
            if (Array.isArray(_data["dpEs"])) {
                this.dpEs = [] as any;
                for (let item of _data["dpEs"])
                    this.dpEs!.push(DemandeExpeditionEtiquetteDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchColisEtiquetteDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchColisEtiquetteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nom"] = this.nom;
        if (Array.isArray(this.dpEs)) {
            data["dpEs"] = [];
            for (let item of this.dpEs)
                data["dpEs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISearchColisEtiquetteDto {
    id?: number;
    nom?: string | undefined;
    dpEs?: DemandeExpeditionEtiquetteDto[] | undefined;
}

export class SearchDemandeExpeditionDto implements ISearchDemandeExpeditionDto {
    id?: number;
    numeroPDL?: string | undefined;
    statutPDL?: string | undefined;
    numeroDC?: string | undefined;
    codeArticle?: string | undefined;
    clientLivre?: string | undefined;
    adresseClientlivre?: string | undefined;
    statut?: EDPEStatut;
    isPrioriteManuelle?: boolean;
    essais?: boolean;
    qualite?: boolean;
    operateur?: string | undefined;
    interruptionId?: number | undefined;
    commentaireInterruption?: string | undefined;
    userId?: number | undefined;
    typePriorite?: EDPETypePriorite;
    paysClientlivre?: string | undefined;

    constructor(data?: ISearchDemandeExpeditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.numeroPDL = _data["numeroPDL"];
            this.statutPDL = _data["statutPDL"];
            this.numeroDC = _data["numeroDC"];
            this.codeArticle = _data["codeArticle"];
            this.clientLivre = _data["clientLivre"];
            this.adresseClientlivre = _data["adresseClientlivre"];
            this.statut = _data["statut"];
            this.isPrioriteManuelle = _data["isPrioriteManuelle"];
            this.essais = _data["essais"];
            this.qualite = _data["qualite"];
            this.operateur = _data["operateur"];
            this.interruptionId = _data["interruptionId"];
            this.commentaireInterruption = _data["commentaireInterruption"];
            this.userId = _data["userId"];
            this.typePriorite = _data["typePriorite"];
            this.paysClientlivre = _data["paysClientlivre"];
        }
    }

    static fromJS(data: any): SearchDemandeExpeditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchDemandeExpeditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["numeroPDL"] = this.numeroPDL;
        data["statutPDL"] = this.statutPDL;
        data["numeroDC"] = this.numeroDC;
        data["codeArticle"] = this.codeArticle;
        data["clientLivre"] = this.clientLivre;
        data["adresseClientlivre"] = this.adresseClientlivre;
        data["statut"] = this.statut;
        data["isPrioriteManuelle"] = this.isPrioriteManuelle;
        data["essais"] = this.essais;
        data["qualite"] = this.qualite;
        data["operateur"] = this.operateur;
        data["interruptionId"] = this.interruptionId;
        data["commentaireInterruption"] = this.commentaireInterruption;
        data["userId"] = this.userId;
        data["typePriorite"] = this.typePriorite;
        data["paysClientlivre"] = this.paysClientlivre;
        return data;
    }
}

export interface ISearchDemandeExpeditionDto {
    id?: number;
    numeroPDL?: string | undefined;
    statutPDL?: string | undefined;
    numeroDC?: string | undefined;
    codeArticle?: string | undefined;
    clientLivre?: string | undefined;
    adresseClientlivre?: string | undefined;
    statut?: EDPEStatut;
    isPrioriteManuelle?: boolean;
    essais?: boolean;
    qualite?: boolean;
    operateur?: string | undefined;
    interruptionId?: number | undefined;
    commentaireInterruption?: string | undefined;
    userId?: number | undefined;
    typePriorite?: EDPETypePriorite;
    paysClientlivre?: string | undefined;
}

export class SearchDemandeExpeditionForLoadingDto implements ISearchDemandeExpeditionForLoadingDto {
    id?: number;
    numeroPDL?: string | undefined;
    statutPDL?: string | undefined;
    numeroDC?: string | undefined;
    codeArticle?: string | undefined;
    clientLivre?: string | undefined;
    adresseClientlivre?: string | undefined;
    paysClientlivre?: string | undefined;
    modeTransport?: EDPEModeTransport;

    constructor(data?: ISearchDemandeExpeditionForLoadingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.numeroPDL = _data["numeroPDL"];
            this.statutPDL = _data["statutPDL"];
            this.numeroDC = _data["numeroDC"];
            this.codeArticle = _data["codeArticle"];
            this.clientLivre = _data["clientLivre"];
            this.adresseClientlivre = _data["adresseClientlivre"];
            this.paysClientlivre = _data["paysClientlivre"];
            this.modeTransport = _data["modeTransport"];
        }
    }

    static fromJS(data: any): SearchDemandeExpeditionForLoadingDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchDemandeExpeditionForLoadingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["numeroPDL"] = this.numeroPDL;
        data["statutPDL"] = this.statutPDL;
        data["numeroDC"] = this.numeroDC;
        data["codeArticle"] = this.codeArticle;
        data["clientLivre"] = this.clientLivre;
        data["adresseClientlivre"] = this.adresseClientlivre;
        data["paysClientlivre"] = this.paysClientlivre;
        data["modeTransport"] = this.modeTransport;
        return data;
    }
}

export interface ISearchDemandeExpeditionForLoadingDto {
    id?: number;
    numeroPDL?: string | undefined;
    statutPDL?: string | undefined;
    numeroDC?: string | undefined;
    codeArticle?: string | undefined;
    clientLivre?: string | undefined;
    adresseClientlivre?: string | undefined;
    paysClientlivre?: string | undefined;
    modeTransport?: EDPEModeTransport;
}

export class SearchDemandeExpeditionForPairingColisDto implements ISearchDemandeExpeditionForPairingColisDto {
    id?: number;
    numeroPDL?: string | undefined;
    statutPDL?: string | undefined;
    numeroDC?: string | undefined;
    codeArticle?: string | undefined;
    clientLivre?: string | undefined;
    adresseClientlivre?: string | undefined;
    tags?: PairingTagDto[] | undefined;
    totalPieces?: number;
    totalPiecesAColiser?: number;
    modifiedDate?: dayjs.Dayjs | undefined;
    paysClientlivre?: string | undefined;
    modeTransport?: EDPEModeTransport;

    constructor(data?: ISearchDemandeExpeditionForPairingColisDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.numeroPDL = _data["numeroPDL"];
            this.statutPDL = _data["statutPDL"];
            this.numeroDC = _data["numeroDC"];
            this.codeArticle = _data["codeArticle"];
            this.clientLivre = _data["clientLivre"];
            this.adresseClientlivre = _data["adresseClientlivre"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(PairingTagDto.fromJS(item));
            }
            this.totalPieces = _data["totalPieces"];
            this.totalPiecesAColiser = _data["totalPiecesAColiser"];
            this.modifiedDate = _data["modifiedDate"] ? dayjs(_data["modifiedDate"].toString()) : undefined as any;
            this.paysClientlivre = _data["paysClientlivre"];
            this.modeTransport = _data["modeTransport"];
        }
    }

    static fromJS(data: any): SearchDemandeExpeditionForPairingColisDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchDemandeExpeditionForPairingColisDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["numeroPDL"] = this.numeroPDL;
        data["statutPDL"] = this.statutPDL;
        data["numeroDC"] = this.numeroDC;
        data["codeArticle"] = this.codeArticle;
        data["clientLivre"] = this.clientLivre;
        data["adresseClientlivre"] = this.adresseClientlivre;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalPieces"] = this.totalPieces;
        data["totalPiecesAColiser"] = this.totalPiecesAColiser;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : undefined as any;
        data["paysClientlivre"] = this.paysClientlivre;
        data["modeTransport"] = this.modeTransport;
        return data;
    }
}

export interface ISearchDemandeExpeditionForPairingColisDto {
    id?: number;
    numeroPDL?: string | undefined;
    statutPDL?: string | undefined;
    numeroDC?: string | undefined;
    codeArticle?: string | undefined;
    clientLivre?: string | undefined;
    adresseClientlivre?: string | undefined;
    tags?: PairingTagDto[] | undefined;
    totalPieces?: number;
    totalPiecesAColiser?: number;
    modifiedDate?: dayjs.Dayjs | undefined;
    paysClientlivre?: string | undefined;
    modeTransport?: EDPEModeTransport;
}

export class SearchPieceDto implements ISearchPieceDto {
    id?: number;
    numeroSerie?: string | undefined;
    isAnomalie?: boolean;
    numeroOf?: string | undefined;
    tagIdentifier?: string | undefined;
    tagId?: number | undefined;
    colisId?: number | undefined;
    position?: SearchPositionDto;
    isVpe?: boolean;
    isInZoneQuarantaine?: boolean;

    constructor(data?: ISearchPieceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.numeroSerie = _data["numeroSerie"];
            this.isAnomalie = _data["isAnomalie"];
            this.numeroOf = _data["numeroOf"];
            this.tagIdentifier = _data["tagIdentifier"];
            this.tagId = _data["tagId"];
            this.colisId = _data["colisId"];
            this.position = _data["position"] ? SearchPositionDto.fromJS(_data["position"]) : undefined as any;
            this.isVpe = _data["isVpe"];
            this.isInZoneQuarantaine = _data["isInZoneQuarantaine"];
        }
    }

    static fromJS(data: any): SearchPieceDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchPieceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["numeroSerie"] = this.numeroSerie;
        data["isAnomalie"] = this.isAnomalie;
        data["numeroOf"] = this.numeroOf;
        data["tagIdentifier"] = this.tagIdentifier;
        data["tagId"] = this.tagId;
        data["colisId"] = this.colisId;
        data["position"] = this.position ? this.position.toJSON() : undefined as any;
        data["isVpe"] = this.isVpe;
        data["isInZoneQuarantaine"] = this.isInZoneQuarantaine;
        return data;
    }
}

export interface ISearchPieceDto {
    id?: number;
    numeroSerie?: string | undefined;
    isAnomalie?: boolean;
    numeroOf?: string | undefined;
    tagIdentifier?: string | undefined;
    tagId?: number | undefined;
    colisId?: number | undefined;
    position?: SearchPositionDto;
    isVpe?: boolean;
    isInZoneQuarantaine?: boolean;
}

export class SearchPositionDto implements ISearchPositionDto {
    id?: number;
    localisation?: string | undefined;
    precision?: number;
    zone?: string | undefined;
    dateUtc?: dayjs.Dayjs;

    constructor(data?: ISearchPositionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.localisation = _data["localisation"];
            this.precision = _data["precision"];
            this.zone = _data["zone"];
            this.dateUtc = _data["dateUtc"] ? dayjs(_data["dateUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SearchPositionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchPositionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["localisation"] = this.localisation;
        data["precision"] = this.precision;
        data["zone"] = this.zone;
        data["dateUtc"] = this.dateUtc ? this.dateUtc.toISOString() : undefined as any;
        return data;
    }
}

export interface ISearchPositionDto {
    id?: number;
    localisation?: string | undefined;
    precision?: number;
    zone?: string | undefined;
    dateUtc?: dayjs.Dayjs;
}

export class SearchPriorisationParametrageDto implements ISearchPriorisationParametrageDto {
    id?: number;
    client?: string | undefined;
    joursSemaine?: string | undefined;
    isPrioritaireLundi?: boolean;
    isPrioritaireMardi?: boolean;
    isPrioritaireMercredi?: boolean;
    isPrioritaireJeudi?: boolean;
    isPrioritaireVendredi?: boolean;

    constructor(data?: ISearchPriorisationParametrageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.client = _data["client"];
            this.joursSemaine = _data["joursSemaine"];
            this.isPrioritaireLundi = _data["isPrioritaireLundi"];
            this.isPrioritaireMardi = _data["isPrioritaireMardi"];
            this.isPrioritaireMercredi = _data["isPrioritaireMercredi"];
            this.isPrioritaireJeudi = _data["isPrioritaireJeudi"];
            this.isPrioritaireVendredi = _data["isPrioritaireVendredi"];
        }
    }

    static fromJS(data: any): SearchPriorisationParametrageDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchPriorisationParametrageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["client"] = this.client;
        data["joursSemaine"] = this.joursSemaine;
        data["isPrioritaireLundi"] = this.isPrioritaireLundi;
        data["isPrioritaireMardi"] = this.isPrioritaireMardi;
        data["isPrioritaireMercredi"] = this.isPrioritaireMercredi;
        data["isPrioritaireJeudi"] = this.isPrioritaireJeudi;
        data["isPrioritaireVendredi"] = this.isPrioritaireVendredi;
        return data;
    }
}

export interface ISearchPriorisationParametrageDto {
    id?: number;
    client?: string | undefined;
    joursSemaine?: string | undefined;
    isPrioritaireLundi?: boolean;
    isPrioritaireMardi?: boolean;
    isPrioritaireMercredi?: boolean;
    isPrioritaireJeudi?: boolean;
    isPrioritaireVendredi?: boolean;
}

export class SearchZoneDto implements ISearchZoneDto {
    id?: number;
    nom?: string | undefined;
    surface?: string | undefined;
    hauteur?: number;
    elevation?: number;
    commentaire?: string | undefined;
    isQuarantaine?: boolean;

    constructor(data?: ISearchZoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nom = _data["nom"];
            this.surface = _data["surface"];
            this.hauteur = _data["hauteur"];
            this.elevation = _data["elevation"];
            this.commentaire = _data["commentaire"];
            this.isQuarantaine = _data["isQuarantaine"];
        }
    }

    static fromJS(data: any): SearchZoneDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchZoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nom"] = this.nom;
        data["surface"] = this.surface;
        data["hauteur"] = this.hauteur;
        data["elevation"] = this.elevation;
        data["commentaire"] = this.commentaire;
        data["isQuarantaine"] = this.isQuarantaine;
        return data;
    }
}

export interface ISearchZoneDto {
    id?: number;
    nom?: string | undefined;
    surface?: string | undefined;
    hauteur?: number;
    elevation?: number;
    commentaire?: string | undefined;
    isQuarantaine?: boolean;
}

export class SettingDto implements ISettingDto {
    id?: number;
    name?: string | undefined;
    value?: string | undefined;
    isEncrypted?: boolean;
    type?: ESettingType;
    userId?: number | undefined;
    createdBy?: number | undefined;
    modifiedBy?: number | undefined;
    createdDate?: dayjs.Dayjs | undefined;
    modifiedDate?: dayjs.Dayjs | undefined;

    constructor(data?: ISettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.isEncrypted = _data["isEncrypted"];
            this.type = _data["type"];
            this.userId = _data["userId"];
            this.createdBy = _data["createdBy"];
            this.modifiedBy = _data["modifiedBy"];
            this.createdDate = _data["createdDate"] ? dayjs(_data["createdDate"].toString()) : undefined as any;
            this.modifiedDate = _data["modifiedDate"] ? dayjs(_data["modifiedDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new SettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["value"] = this.value;
        data["isEncrypted"] = this.isEncrypted;
        data["type"] = this.type;
        data["userId"] = this.userId;
        data["createdBy"] = this.createdBy;
        data["modifiedBy"] = this.modifiedBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : undefined as any;
        return data;
    }
}

export interface ISettingDto {
    id?: number;
    name?: string | undefined;
    value?: string | undefined;
    isEncrypted?: boolean;
    type?: ESettingType;
    userId?: number | undefined;
    createdBy?: number | undefined;
    modifiedBy?: number | undefined;
    createdDate?: dayjs.Dayjs | undefined;
    modifiedDate?: dayjs.Dayjs | undefined;
}

export class TagPairedDto implements ITagPairedDto {
    id?: number;
    tagIdentifier?: string | undefined;
    codeZones?: string | undefined;
    dateAppairage?: dayjs.Dayjs | undefined;
    pieces?: PairingPieceDto[] | undefined;
    historiqueAppairages?: HistoriqueAppairageDto[] | undefined;
    localisation?: string | undefined;
    readonly numeroOf?: string | undefined;
    readonly nomPieces?: string | undefined;

    constructor(data?: ITagPairedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tagIdentifier = _data["tagIdentifier"];
            this.codeZones = _data["codeZones"];
            this.dateAppairage = _data["dateAppairage"] ? dayjs(_data["dateAppairage"].toString()) : undefined as any;
            if (Array.isArray(_data["pieces"])) {
                this.pieces = [] as any;
                for (let item of _data["pieces"])
                    this.pieces!.push(PairingPieceDto.fromJS(item));
            }
            if (Array.isArray(_data["historiqueAppairages"])) {
                this.historiqueAppairages = [] as any;
                for (let item of _data["historiqueAppairages"])
                    this.historiqueAppairages!.push(HistoriqueAppairageDto.fromJS(item));
            }
            this.localisation = _data["localisation"];
            (this as any).numeroOf = _data["numeroOf"];
            (this as any).nomPieces = _data["nomPieces"];
        }
    }

    static fromJS(data: any): TagPairedDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagPairedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tagIdentifier"] = this.tagIdentifier;
        data["codeZones"] = this.codeZones;
        data["dateAppairage"] = this.dateAppairage ? this.dateAppairage.toISOString() : undefined as any;
        if (Array.isArray(this.pieces)) {
            data["pieces"] = [];
            for (let item of this.pieces)
                data["pieces"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.historiqueAppairages)) {
            data["historiqueAppairages"] = [];
            for (let item of this.historiqueAppairages)
                data["historiqueAppairages"].push(item ? item.toJSON() : undefined as any);
        }
        data["localisation"] = this.localisation;
        data["numeroOf"] = this.numeroOf;
        data["nomPieces"] = this.nomPieces;
        return data;
    }
}

export interface ITagPairedDto {
    id?: number;
    tagIdentifier?: string | undefined;
    codeZones?: string | undefined;
    dateAppairage?: dayjs.Dayjs | undefined;
    pieces?: PairingPieceDto[] | undefined;
    historiqueAppairages?: HistoriqueAppairageDto[] | undefined;
    localisation?: string | undefined;
    numeroOf?: string | undefined;
    nomPieces?: string | undefined;
}

export class TagsChoice implements ITagsChoice {
    tag_uid?: number;
    origin?: string | undefined;
    operator_choice?: string | undefined;

    constructor(data?: ITagsChoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tag_uid = _data["tag_uid"];
            this.origin = _data["origin"];
            this.operator_choice = _data["operator_choice"];
        }
    }

    static fromJS(data: any): TagsChoice {
        data = typeof data === 'object' ? data : {};
        let result = new TagsChoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tag_uid"] = this.tag_uid;
        data["origin"] = this.origin;
        data["operator_choice"] = this.operator_choice;
        return data;
    }
}

export interface ITagsChoice {
    tag_uid?: number;
    origin?: string | undefined;
    operator_choice?: string | undefined;
}

export class TouaregContent implements ITouaregContent {
    state?: string | undefined;
    countdown?: number;
    touareg_uid?: number;
    genesis_time?: dayjs.Dayjs;
    algorithm_mode?: string | undefined;
    last_action_uid?: string | undefined;
    state_update_date?: dayjs.Dayjs;
    countdown_start_date?: dayjs.Dayjs;
    state_machine_session_uid?: string | undefined;
    tags_list?: TouaregTag[] | undefined;
    last_session?: TouaregLastSession;

    constructor(data?: ITouaregContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.countdown = _data["countdown"];
            this.touareg_uid = _data["touareg_uid"];
            this.genesis_time = _data["genesis_time"] ? dayjs(_data["genesis_time"].toString()) : undefined as any;
            this.algorithm_mode = _data["algorithm_mode"];
            this.last_action_uid = _data["last_action_uid"];
            this.state_update_date = _data["state_update_date"] ? dayjs(_data["state_update_date"].toString()) : undefined as any;
            this.countdown_start_date = _data["countdown_start_date"] ? dayjs(_data["countdown_start_date"].toString()) : undefined as any;
            this.state_machine_session_uid = _data["state_machine_session_uid"];
            if (Array.isArray(_data["tags_list"])) {
                this.tags_list = [] as any;
                for (let item of _data["tags_list"])
                    this.tags_list!.push(TouaregTag.fromJS(item));
            }
            this.last_session = _data["last_session"] ? TouaregLastSession.fromJS(_data["last_session"]) : undefined as any;
        }
    }

    static fromJS(data: any): TouaregContent {
        data = typeof data === 'object' ? data : {};
        let result = new TouaregContent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["countdown"] = this.countdown;
        data["touareg_uid"] = this.touareg_uid;
        data["genesis_time"] = this.genesis_time ? this.genesis_time.toISOString() : undefined as any;
        data["algorithm_mode"] = this.algorithm_mode;
        data["last_action_uid"] = this.last_action_uid;
        data["state_update_date"] = this.state_update_date ? this.state_update_date.toISOString() : undefined as any;
        data["countdown_start_date"] = this.countdown_start_date ? this.countdown_start_date.toISOString() : undefined as any;
        data["state_machine_session_uid"] = this.state_machine_session_uid;
        if (Array.isArray(this.tags_list)) {
            data["tags_list"] = [];
            for (let item of this.tags_list)
                data["tags_list"].push(item ? item.toJSON() : undefined as any);
        }
        data["last_session"] = this.last_session ? this.last_session.toJSON() : undefined as any;
        return data;
    }
}

export interface ITouaregContent {
    state?: string | undefined;
    countdown?: number;
    touareg_uid?: number;
    genesis_time?: dayjs.Dayjs;
    algorithm_mode?: string | undefined;
    last_action_uid?: string | undefined;
    state_update_date?: dayjs.Dayjs;
    countdown_start_date?: dayjs.Dayjs;
    state_machine_session_uid?: string | undefined;
    tags_list?: TouaregTag[] | undefined;
    last_session?: TouaregLastSession;
}

export class TouaregData implements ITouaregData {
    trace_touareg_controller_state_dm?: TouaregTrace[] | undefined;

    constructor(data?: ITouaregData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["trace_touareg_controller_state_dm"])) {
                this.trace_touareg_controller_state_dm = [] as any;
                for (let item of _data["trace_touareg_controller_state_dm"])
                    this.trace_touareg_controller_state_dm!.push(TouaregTrace.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TouaregData {
        data = typeof data === 'object' ? data : {};
        let result = new TouaregData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.trace_touareg_controller_state_dm)) {
            data["trace_touareg_controller_state_dm"] = [];
            for (let item of this.trace_touareg_controller_state_dm)
                data["trace_touareg_controller_state_dm"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITouaregData {
    trace_touareg_controller_state_dm?: TouaregTrace[] | undefined;
}

export class TouaregDto implements ITouaregDto {
    data?: TouaregData;
    system_time?: dayjs.Dayjs;
    bfs_time?: dayjs.Dayjs;

    constructor(data?: ITouaregDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? TouaregData.fromJS(_data["data"]) : undefined as any;
            this.system_time = _data["system_time"] ? dayjs(_data["system_time"].toString()) : undefined as any;
            this.bfs_time = _data["bfs_time"] ? dayjs(_data["bfs_time"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): TouaregDto {
        data = typeof data === 'object' ? data : {};
        let result = new TouaregDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["system_time"] = this.system_time ? this.system_time.toISOString() : undefined as any;
        data["bfs_time"] = this.bfs_time ? this.bfs_time.toISOString() : undefined as any;
        return data;
    }
}

export interface ITouaregDto {
    data?: TouaregData;
    system_time?: dayjs.Dayjs;
    bfs_time?: dayjs.Dayjs;
}

export class TouaregGem implements ITouaregGem {

    constructor(data?: ITouaregGem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): TouaregGem {
        data = typeof data === 'object' ? data : {};
        let result = new TouaregGem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ITouaregGem {
}

export class TouaregLastSession implements ITouaregLastSession {
    tags_list?: TouaregTag[] | undefined;
    state_update_date?: dayjs.Dayjs;
    state_machine_session_uid?: string | undefined;

    constructor(data?: ITouaregLastSession) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tags_list"])) {
                this.tags_list = [] as any;
                for (let item of _data["tags_list"])
                    this.tags_list!.push(TouaregTag.fromJS(item));
            }
            this.state_update_date = _data["state_update_date"] ? dayjs(_data["state_update_date"].toString()) : undefined as any;
            this.state_machine_session_uid = _data["state_machine_session_uid"];
        }
    }

    static fromJS(data: any): TouaregLastSession {
        data = typeof data === 'object' ? data : {};
        let result = new TouaregLastSession();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tags_list)) {
            data["tags_list"] = [];
            for (let item of this.tags_list)
                data["tags_list"].push(item ? item.toJSON() : undefined as any);
        }
        data["state_update_date"] = this.state_update_date ? this.state_update_date.toISOString() : undefined as any;
        data["state_machine_session_uid"] = this.state_machine_session_uid;
        return data;
    }
}

export interface ITouaregLastSession {
    tags_list?: TouaregTag[] | undefined;
    state_update_date?: dayjs.Dayjs;
    state_machine_session_uid?: string | undefined;
}

export class TouaregOperatorActionDto implements ITouaregOperatorActionDto {
    touareg_uid?: number;
    choice_update_date?: string | undefined;
    state_machine_session_uid?: string | undefined;
    action_uid?: string | undefined;
    operator_action_type?: string | undefined;
    algorithm_mode?: string | undefined;
    tags_choices?: TagsChoice[] | undefined;

    constructor(data?: ITouaregOperatorActionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.touareg_uid = _data["touareg_uid"];
            this.choice_update_date = _data["choice_update_date"];
            this.state_machine_session_uid = _data["state_machine_session_uid"];
            this.action_uid = _data["action_uid"];
            this.operator_action_type = _data["operator_action_type"];
            this.algorithm_mode = _data["algorithm_mode"];
            if (Array.isArray(_data["tags_choices"])) {
                this.tags_choices = [] as any;
                for (let item of _data["tags_choices"])
                    this.tags_choices!.push(TagsChoice.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TouaregOperatorActionDto {
        data = typeof data === 'object' ? data : {};
        let result = new TouaregOperatorActionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["touareg_uid"] = this.touareg_uid;
        data["choice_update_date"] = this.choice_update_date;
        data["state_machine_session_uid"] = this.state_machine_session_uid;
        data["action_uid"] = this.action_uid;
        data["operator_action_type"] = this.operator_action_type;
        data["algorithm_mode"] = this.algorithm_mode;
        if (Array.isArray(this.tags_choices)) {
            data["tags_choices"] = [];
            for (let item of this.tags_choices)
                data["tags_choices"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITouaregOperatorActionDto {
    touareg_uid?: number;
    choice_update_date?: string | undefined;
    state_machine_session_uid?: string | undefined;
    action_uid?: string | undefined;
    operator_action_type?: string | undefined;
    algorithm_mode?: string | undefined;
    tags_choices?: TagsChoice[] | undefined;
}

export class TouaregTag implements ITouaregTag {
    gem?: TouaregGem;
    origin?: string | undefined;
    tag_uid?: number;
    algo_choice?: string | undefined;
    load_status?: string | undefined;
    operator_choice?: string | undefined;

    constructor(data?: ITouaregTag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gem = _data["gem"] ? TouaregGem.fromJS(_data["gem"]) : undefined as any;
            this.origin = _data["origin"];
            this.tag_uid = _data["tag_uid"];
            this.algo_choice = _data["algo_choice"];
            this.load_status = _data["load_status"];
            this.operator_choice = _data["operator_choice"];
        }
    }

    static fromJS(data: any): TouaregTag {
        data = typeof data === 'object' ? data : {};
        let result = new TouaregTag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gem"] = this.gem ? this.gem.toJSON() : undefined as any;
        data["origin"] = this.origin;
        data["tag_uid"] = this.tag_uid;
        data["algo_choice"] = this.algo_choice;
        data["load_status"] = this.load_status;
        data["operator_choice"] = this.operator_choice;
        return data;
    }
}

export interface ITouaregTag {
    gem?: TouaregGem;
    origin?: string | undefined;
    tag_uid?: number;
    algo_choice?: string | undefined;
    load_status?: string | undefined;
    operator_choice?: string | undefined;
}

export class TouaregTrace implements ITouaregTrace {
    content?: TouaregContent;

    constructor(data?: ITouaregTrace) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.content = _data["content"] ? TouaregContent.fromJS(_data["content"]) : undefined as any;
        }
    }

    static fromJS(data: any): TouaregTrace {
        data = typeof data === 'object' ? data : {};
        let result = new TouaregTrace();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content ? this.content.toJSON() : undefined as any;
        return data;
    }
}

export interface ITouaregTrace {
    content?: TouaregContent;
}

export class TraiteDemandeTransportDto implements ITraiteDemandeTransportDto {
    id?: number;
    traitee?: boolean;

    constructor(data?: ITraiteDemandeTransportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.traitee = _data["traitee"];
        }
    }

    static fromJS(data: any): TraiteDemandeTransportDto {
        data = typeof data === 'object' ? data : {};
        let result = new TraiteDemandeTransportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["traitee"] = this.traitee;
        return data;
    }
}

export interface ITraiteDemandeTransportDto {
    id?: number;
    traitee?: boolean;
}

export class UpdateDemandeExpeDto implements IUpdateDemandeExpeDto {
    id?: number;
    statut?: EDPEStatut;
    userId?: number | undefined;
    isPrioriteManuelle?: boolean;

    constructor(data?: IUpdateDemandeExpeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.statut = _data["statut"];
            this.userId = _data["userId"];
            this.isPrioriteManuelle = _data["isPrioriteManuelle"];
        }
    }

    static fromJS(data: any): UpdateDemandeExpeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDemandeExpeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["statut"] = this.statut;
        data["userId"] = this.userId;
        data["isPrioriteManuelle"] = this.isPrioriteManuelle;
        return data;
    }
}

export interface IUpdateDemandeExpeDto {
    id?: number;
    statut?: EDPEStatut;
    userId?: number | undefined;
    isPrioriteManuelle?: boolean;
}

export class UpdatePairingDto implements IUpdatePairingDto {
    tagIdentifier?: string | undefined;
    pairings?: MovePairingPieceDto[] | undefined;

    constructor(data?: IUpdatePairingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagIdentifier = _data["tagIdentifier"];
            if (Array.isArray(_data["pairings"])) {
                this.pairings = [] as any;
                for (let item of _data["pairings"])
                    this.pairings!.push(MovePairingPieceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdatePairingDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePairingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagIdentifier"] = this.tagIdentifier;
        if (Array.isArray(this.pairings)) {
            data["pairings"] = [];
            for (let item of this.pairings)
                data["pairings"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdatePairingDto {
    tagIdentifier?: string | undefined;
    pairings?: MovePairingPieceDto[] | undefined;
}

export class ZoneDto implements IZoneDto {
    id?: number;
    nom?: string | undefined;
    surface?: string | undefined;
    hauteur?: number;
    elevation?: number;
    commentaire?: string | undefined;
    isQuarantaine?: boolean;
    codeGisement?: string | undefined;
    isToujoursVisible?: boolean;

    constructor(data?: IZoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nom = _data["nom"];
            this.surface = _data["surface"];
            this.hauteur = _data["hauteur"];
            this.elevation = _data["elevation"];
            this.commentaire = _data["commentaire"];
            this.isQuarantaine = _data["isQuarantaine"];
            this.codeGisement = _data["codeGisement"];
            this.isToujoursVisible = _data["isToujoursVisible"];
        }
    }

    static fromJS(data: any): ZoneDto {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nom"] = this.nom;
        data["surface"] = this.surface;
        data["hauteur"] = this.hauteur;
        data["elevation"] = this.elevation;
        data["commentaire"] = this.commentaire;
        data["isQuarantaine"] = this.isQuarantaine;
        data["codeGisement"] = this.codeGisement;
        data["isToujoursVisible"] = this.isToujoursVisible;
        return data;
    }
}

export interface IZoneDto {
    id?: number;
    nom?: string | undefined;
    surface?: string | undefined;
    hauteur?: number;
    elevation?: number;
    commentaire?: string | undefined;
    isQuarantaine?: boolean;
    codeGisement?: string | undefined;
    isToujoursVisible?: boolean;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}